<template>
  <div class="designerMain" ref="designerMain">

    <!-- Toolbar HTML -->
    <div class="toolbarMain">
      <div class="toolbarHamburgerMain">
        <button :class="[ (toolbarData['hamburgerShow'] ? 'selected' : '') ]" @click="toolbarBtn('hamburger', !toolbarData['hamburgerShow'])"> <svg viewBox="0 0 500 500"> <path :d="icon['hamburger']"/> </svg> </button>
        <div class="toolbarHamburger" v-if="toolbarData['hamburgerShow']">
          <button class="toolbarHamburgerBtn" @click="toolbarBtn('explorer', 'form')" v-if="!quickPrint">&#8226; Manage Forms</button>
          <button class="toolbarHamburgerBtn" @click="toolbarBtn('explorer', 'image')" v-if="!quickPrint">&#8226; Manage Images</button>
          <button class="toolbarHamburgerBtn" @click="toolbarBtn('explorer', 'key')" v-if="!quickPrint">&#8226; Manage Keys</button>
          <button class="toolbarHamburgerBtn" @click="toolbarBtn('save', 'toggle')" v-if="!quickPrint">&#8226; Save</button>
          <button class="toolbarHamburgerBtn" @click="toolbarBtn('print', '')">&#8226; Print</button>
          <button class="toolbarHamburgerBtn" @click="toolbarBtn('reset', false)" v-if="!quickPrint">&#8226; Reset</button>
          <button class="toolbarHamburgerBtn" @click="toolbarBtn('console', 'data')" v-if="mainData['console'] && !quickPrint">&#8226; Log Data</button>

          <button class="toolbarHamburgerBtn" @click="toolbarBtn('cancel', '')" v-if="quickPrint">&#8226; Cancel</button>
        </div>
      </div>

      <!-- <div class="toolBarQuickPrintMain">
        <button class="toolbarHamburgerBtn" @click="toolbarBtn('print', '')">&#8226; Print</button>
        <button class="toolbarHamburgerBtn" @click="toolbarBtn('cancel', '')">&#8226; Cancel</button>
      </div> -->

      <!-- Console HTML -->
      <div class="consoleMain" v-if="mainData['console']">
        <div :class="[ 'consoleInd', (mainData['loaded'] ? 'power' : '')]">L</div>
        <div class="consoleSpacer"></div>
        <div :class="[ 'consoleInd', (mouseData['editorResizeMouseDown'] ? 'power' : '')]">RD</div>
        <div class="consoleSpacer"></div>
        <div :class="[ 'consoleInd', (mouseData['pagerMouseDown'] ? 'power' : '')]">PD</div>
        <div :class="[ 'consoleInd', (mouseData['pagerMouseOver'] ? 'power' : '')]">PO</div>
        <div :class="[ 'consoleInd', (mouseData['pagerMouseMove'] ? 'power' : '')]">PM</div>
      </div>

      <div class="toolbarFunctionsMain">
        <div class="toolbarSection">
          <button @click="toolbarBtn('zoomOut', '')"><svg viewBox="0 0 500 500"><path :d="icon['minus']"/></svg></button>
          <input class="toolbarSectionInput" type="text" :value="(toolbarData['zoomLevel'] * 100).toFixed(0) + '%'" :disabled="true"/>
          <button @click="toolbarBtn('zoomIn', '')"><svg viewBox="0 0 500 500"><path :d="icon['plus']"/></svg></button>
        </div>
        <div class="toolBarSectionBorder"></div>
        <div class="toolbarSection">
          <button @click="toolbarBtn('pageUp', '')"><svg viewBox="0 0 500 500"><path :d="icon['uparrow']"/></svg></button>
          <input class="toolbarSectionInput" type="text" :value="toolbarData['pageCurrent'] + '/' + toolbarData['pageTotal']" :disabled="true"/>
          <button @click="toolbarBtn('pageDown', '')"><svg viewBox="0 0 500 500"><path :d="icon['downarrow']"/></svg></button>
        </div>
      </div>
    </div>

    <!-- Editor HTML -->
    <div class="editorMain" ref="editorMain" v-if="!(mainData['print'] || quickPrint)" :style="{
      'left': ((editorData['fieldSel'] ? (((editorData['fieldSel']['posX1'] * toolbarData['zoomLevel']) - 8) + editorData['pageOffsetX'] - mouseData['pagerScrollLeft']) : 0) + 'px'),
      'top': ((editorData['fieldSel'] ? (((editorData['fieldSel']['posY1'] * toolbarData['zoomLevel']) - 8) + editorData['pageOffsetY'] - mouseData['pagerScrollTop']) : 0) + 'px'),
      'width': ((editorData['fieldSel'] ? (((editorData['fieldSel']['posX2'] - editorData['fieldSel']['posX1']) * toolbarData['zoomLevel']) + 16) : 0) + 'px'),
      'height': ((editorData['fieldSel'] ? (((editorData['fieldSel']['posY2'] - editorData['fieldSel']['posY1']) * toolbarData['zoomLevel']) + 16) : 0) + 'px')}">
      

      <!-- Editor resize HTML -->
      <div class="editorResize" :style="{ 'top': '0px', 'left' : '0px', 'cursor': 'nw-resize',
        'pointer-events': ((mouseData['pagerMouseDown'] || mouseData['editorResizeMouseDown']) ? 'none' : '') }"
        @mousedown="editorBtn('resize', 'nw', $event)"></div>
      <div class="editorResize" :style="{ 'top': '0px', 'right' : '0px', 'cursor': 'ne-resize',
        'pointer-events': ((mouseData['pagerMouseDown'] || mouseData['editorResizeMouseDown']) ? 'none' : '') }"
        @mousedown="editorBtn('resize', 'ne', $event)"></div>
      <div class="editorResize" :style="{ 'bottom': '0px', 'left' : '0px', 'cursor': 'sw-resize',
        'pointer-events': ((mouseData['pagerMouseDown'] || mouseData['editorResizeMouseDown']) ? 'none' : '') }"
        @mousedown="editorBtn('resize', 'sw', $event)"></div>
      <div class="editorResize" :style="{ 'bottom': '0px', 'right' : '0px', 'cursor': 'se-resize',
        'pointer-events': ((mouseData['pagerMouseDown'] || mouseData['editorResizeMouseDown']) ? 'none' : '') }"
        @mousedown="editorBtn('resize', 'se', $event)"></div>

      <!-- Defocus HTML -->
      <div class="editorDefocus" :style="{ 'top': '10px', 'bottom': '10px', 'left' : '0px',
        'pointer-events': ((mouseData['pagerMouseDown'] || mouseData['editorResizeMouseDown']) ? 'none' : '') }"></div>
      <div class="editorDefocus" :style="{ 'top': '10px', 'bottom': '10px', 'right' : '0px',
        'pointer-events': ((mouseData['pagerMouseDown'] || mouseData['editorResizeMouseDown']) ? 'none' : '') }"></div>
    </div>

    <!-- New Field Selection HTML -->
    <div class="newFieldMain" v-if="editorData['newFieldShow']" :style="{
      'top': (((editorData['newFieldPosY'] * toolbarData['zoomLevel']) + editorData['pageOffsetY'] - mouseData['pagerScrollTop']) + 'px'),
      'left': ((((editorData['newFieldPosX'] * toolbarData['zoomLevel']) - 100) + editorData['pageOffsetX'] - mouseData['pagerScrollLeft']) + 'px'),
      }">
      <div class="newFieldTitle">Add new field</div>
      <div class="newFieldList">
        <div class="newFieldItem" @click="fieldNew('text', '', $event)">Text</div>
        <div class="newFieldItem" @click="fieldNew('table', '', $event)">Table</div>
        <div class="newFieldItem" @click="fieldNew('tsmanifest', '', $event)">TSManifest</div>
      </div>
    </div>

    <!-- Components HTML -->
    <Explorer v-if="toolbarData['explorerShow']" :show.sync="toolbarData['explorerShow']" :page.sync="toolbarData['explorerPage']"
      @explorerClose="toolbarBtn('explorer', 'close')" @formSelect="toolbarBtn('explorerSelect', $event)"/>

    <!-- Save HTML -->
    <div class="saveMain" v-if="toolbarData['saveFileShow']">
      <div class="saveBody">
        <input placeHolder="File Name" v-model="toolbarData['saveFileName']"/>
        <div class="saveList">
          <div v-for="(f, i) in toolbarData['forms']" :key="'form' + i" :style="{ 'display': ((f['file'].split('\.')[0].search(toolbarData['saveFileName'].trim()) >= 0) ? '' : 'none') }">{{f['file'].split('\.')[0]}}</div>
          <div v-if="(toolbarData['forms'].filter((f2) => { return (f2['file'].split('\.')[0].search(toolbarData['saveFileName'].trim()) >= 0); }))['length'] <= 0" :style="{ 
            'width': '100%', 
            'height': 'auto', 
            'display': 'flex', 
            'align-items': 'center', 
            'justify-content': 'center', 
            'user-select': 'none', 
            'color': '#199400' }">No Duplicates</div>
        </div>
        <div class="saveFunctions">
          <button class="saveButton" @click="toolbarBtn('save', 'save')" :disabled="!toolbarData['saveFileName']">Save</button>
          <button class="saveButton" @click="toolbarBtn('save', 'toggle')">Cancel</button>
        </div>
      </div>
    </div>

    <!-- Pager HTML -->
    <div class="pagerMain" ref="pagerMain" id="pager"
      @dblclick="pagerDblClick('', $event)"
      @mousedown="pagerMouseDown('', $event)"
      @mouseup="pagerMouseUp('', $event)"
      @mousemove="pagerMouseMove('', $event)"
      @mouseover="pagerMouseOver('', $event)"
      @mouseleave="pagerMouseLeave('', $event)"
      @scroll="pagerScroll('', $event)">

      <div class="pageMargin" :style="{
        'min-width': ((90 * toolbarData['zoomLevel']) + 'px')}"></div>
      <div class="pageMain" ref="pageMain" id="page" :style="{
        'position': 'relative',
        'overflow': (mainData['print'] || quickPrint) ? 'hidden' : '',
        'min-width': ((pageDefault[pageData['selection']]['properties']['widthpx'] * toolbarData['zoomLevel']) + 'px'),
        'min-height' : (((pageDefault[pageData['selection']]['properties']['heightpx'] * toolbarData['pageTotal']) * toolbarData['zoomLevel']) + 'px'),
        'max-width': ((pageDefault[pageData['selection']]['properties']['widthpx'] * toolbarData['zoomLevel']) + 'px'),
        'max-height' : (((pageDefault[pageData['selection']]['properties']['heightpx'] * toolbarData['pageTotal']) * toolbarData['zoomLevel']) + 'px')}">

        <div class="pageBreak" v-for="(b, i) in mainData['pages']" :key="'pagebreak' + i" :style="{ 
            'position': 'absolute',
            'top': ((i * (pageDefault[pageData['selection']]['properties']['heightpx'] * toolbarData['zoomLevel'])) + 'px'),
            'display': 'flex',
            'align-items': 'center',
            'justify-content': 'center'}">

          <svg class="pageGrid" :viewBox="'0 0 ' + (pageDefault[pageData['selection']]['properties']['widthmm'] * 10) + ' ' + (pageDefault[pageData['selection']]['properties']['heightmm'] * 10)"  v-if="!quickPrint" :style="{
            'bottom': (-(pageDefault[pageData['selection']]['properties']['heightpx'] * toolbarData['zoomLevel']) + 'px')}">.
            
            <path :d="icon['grid']"/>
          </svg>

          <div class="pageBreakText" v-if="!quickPrint">{{i + 1}}</div>
          <svg viewBox="0 0 800 500" v-if="!quickPrint"><path :d="icon['pagebreak']"
            @click="toolbarBtn('editorPage', b)"/></svg>

          <div class="pageBreakImg" :id="('pageBreak' + b['id'])" :style="{
            'max-height': ((pageDefault[pageData['selection']]['properties']['heightpx'] * toolbarData['zoomLevel']) + 'px'),
            'border-top': 'solid 1px #0004',
            'bottom': (-(pageDefault[pageData['selection']]['properties']['heightpx'] * toolbarData['zoomLevel']) + 'px')}">

          </div>

          <div class="pageEditorMain" v-if="editorData['pageSel'] && editorData['pageSel']['id'] == b['id']">
            <select ref="editorPageImg" @change="toolbarBtn('editorPageImg', b)" v-model="editorData['pageSel']['image']" >
              <option selected disabled value=""> Select Background </option>
              <option v-for="(img, i) in toolbarData['images']" :key="'image' + i">{{img['file']}}</option>
            </select>
            <select ref="editorPageSize" @change="toolbarBtn('editorPageSize', b)" v-model="pageData['selection']">
              <option v-for="(size, i) in Object.keys(pageDefault)" :key="'image' + i">{{size}}</option>
            </select>
            <select ref="editorDataset" @change="toolbarBtn('editorDataset', b)" v-model="pageData['dataset']">
              <option v-for="(set, i) in toolbarData['datasets']" :key="'dataset' + i">{{set['file'].replace('\.json', '')}}</option>
            </select>
          </div>
        </div>

        <!-- Field HTML -->
        <div class="fieldMain" id="field" v-for="(f, i) in mainData['fields']" :key="'field' + i" 
        
          @mousedown="fieldMouseDown(f, $event)" 
          @mouseup="fieldMouseUp(f, $event)" 
          :style="{
            'position': 'absolute',
            'z-index': '10',
            'background-color': ((f['type'] && !(mainData['print'] || quickPrint)) ? (fieldColors[f['type']]['BGColor']) : ''),
            'border': ((f['type'] && !(mainData['print'] || quickPrint)) ? (('solid 1px ' + fieldColors[f['type']]['BDColor'])) : ''),

            'left': ((f['posX1'] * toolbarData['zoomLevel']) + 'px'),
            'top': ((f['posY1'] * toolbarData['zoomLevel']) + 'px'),
            'width': (((f['posX2'] - f['posX1']) * toolbarData['zoomLevel']) + 'px'),
            'height': (((f['posY2'] - f['posY1']) * toolbarData['zoomLevel']) + 'px'),
            'pointer-events': ((mouseData['pagerMouseMove'] || mouseData['editorResizeMouseDown']) ? 'none' : ''),
            'z-index': ((editorData['fieldSel'] ? (editorData['fieldSel']['id'] == f['id']) : false) ? '1000' : '')}">
          
          <!-- <span style="width:100%; height:100%; font-size:10px; text-align:center; display:flex; align-items:center; justify-content:center;">{{f['id']}}</span> -->
          <designerText v-if="f['type'] == 'text'" 
            :style="{ 'pointer-events': ((mouseData['pagerMouseDown'] || !editorData['fieldSel']) ? 'none' : (((editorData['fieldSel']['id'] == f['id']) ? '' : 'none'))) }"
            :data="f" :printData.sync="mainData['data']" :properties.sync="f['properties']" :zoomLevel="toolbarData['zoomLevel']" :fontPtPx="pageData['fontptpx']" :print="(mainData['print'] || quickPrint)"/>

          <designerTable v-if="f['type'] == 'table'" 
            :style="{ 'pointer-events': ((mouseData['pagerMouseDown'] || !editorData['fieldSel']) ? 'none' : (((editorData['fieldSel']['id'] == f['id']) ? '' : 'none'))) }"
            :data="f" :printData="mainData['data']" :properties.sync="f['properties']" :zoomLevel="toolbarData['zoomLevel']" :fontPtPx="pageData['fontptpx']" :print="(mainData['print'] || quickPrint)"/>

          <designerTSManifest v-if="f['type'] == 'tsmanifest'" 
            :style="{ 'pointer-events': ((mouseData['pagerMouseDown'] || !editorData['fieldSel']) ? 'none' : (((editorData['fieldSel']['id'] == f['id']) ? '' : 'none'))) }"
            :data="f" :printData="mainData['data']" :properties.sync="f['properties']" :zoomLevel="toolbarData['zoomLevel']" :fontPtPx="pageData['fontptpx']" :print="(mainData['print'] || quickPrint)"/>

          <designerCNEHL v-if="f['type'] == 'cnehl'" 
            :style="{ 'pointer-events': ((mouseData['pagerMouseDown'] || !editorData['fieldSel']) ? 'none' : (((editorData['fieldSel']['id'] == f['id']) ? '' : 'none'))) }"
            :data="f" :printData="mainData['data']" :properties.sync="f['properties']" :zoomLevel="toolbarData['zoomLevel']" :fontPtPx="pageData['fontptpx']" :print="(mainData['print'] || quickPrint)"/>
          
          <designerCNFMH v-if="f['type'] == 'cnfmh'" 
            :style="{ 'pointer-events': ((mouseData['pagerMouseDown'] || !editorData['fieldSel']) ? 'none' : (((editorData['fieldSel']['id'] == f['id']) ? '' : 'none'))) }"
            :data="f" :printData="mainData['data']" :properties.sync="f['properties']" :zoomLevel="toolbarData['zoomLevel']" :fontPtPx="pageData['fontptpx']" :print="(mainData['print'] || quickPrint)"/>
          
          <designerCNEJ v-if="f['type'] == 'cnej'" 
            :style="{ 'pointer-events': ((mouseData['pagerMouseDown'] || !editorData['fieldSel']) ? 'none' : (((editorData['fieldSel']['id'] == f['id']) ? '' : 'none'))) }"
            :data="f" :printData="mainData['data']" :properties.sync="f['properties']" :zoomLevel="toolbarData['zoomLevel']" :fontPtPx="pageData['fontptpx']" :print="(mainData['print'] || quickPrint)"/>
          
          <designerCNTSL v-if="f['type'] == 'cntsl'" 
            :style="{ 'pointer-events': ((mouseData['pagerMouseDown'] || !editorData['fieldSel']) ? 'none' : (((editorData['fieldSel']['id'] == f['id']) ? '' : 'none'))) }"
            :data="f" :printData="mainData['data']" :properties.sync="f['properties']" :zoomLevel="toolbarData['zoomLevel']" :fontPtPx="pageData['fontptpx']" :print="(mainData['print'] || quickPrint)"/>
        </div>

      </div>
      <div class="pageMargin" :style="{
        'min-width': ((90 * toolbarData['zoomLevel']) + 'px')}"></div>

    </div>

  </div>
</template>

<script>
  /* eslint-disable */
  import Explorer from '@/components/reportDesigner/Explorer.vue';

  //-- Fields
  import designerText from '@/components/reportDesigner/fields/Text.vue';
  import designerTable from '@/components/reportDesigner/fields/Table.vue';

  //-- Custom Fields
  import designerTSManifest from '@/components/reportDesigner/customFields/TSManifest.vue';
  import designerCNEHL from '@/components/reportDesigner/customFields/CNs/CNEHL.vue';
  import designerCNFMH from '@/components/reportDesigner/customFields/CNs/CNFMH.vue';
  import designerCNEJ from '@/components/reportDesigner/customFields/CNs/CNEJ.vue';
  import designerCNTSL from '@/components/reportDesigner/customFields/CNs/CNTSL.vue';
  
  export default {
    name: 'designer',
    components: {
      Explorer, designerText, designerTable, designerTSManifest, designerCNEHL, designerCNFMH, designerCNEJ, designerCNTSL
    },
    props: {
      data: { type: Object, default: function() { return {
        // 'Test': [
        //   {'name': 'Yes', 'age': '2', 'occupation': 'doctor'},
        //   {'name': 'Yes', 'age': '5', 'occupation': 'doctor'},
        //   {'name': 'Yes', 'age': '3', 'occupation': 'doctor'},
        // ],
        // 'Test2': [
        //   {'country': 'Malaysia', 'city': 'Subang'},
        //   {'country': 'Somewhere', 'city': 'Test'},
        // ],
        // 'Test3': 'Hello',
        // 'Test4': 'World',
      }; }},
      form: { type: String, default: '' },
      quickPrint: { type: Boolean, default: false},
    },
    data() { 
      return {
        mainData: {
          'pages': [
            {
              'version': 2,
              'id': 0,
              'image': '',
              'properties': {
                'default': true,
                'widthpx': 794,
                'heightpx': 1123,
                'widthmm': 210,
                'heightmm': 297,
              },
            },
          ],
          'fields': [],
          'form': '',

          'data': {'Test': []},

          'print': false,
          'loaded': false,
          'console': true,
        },

        toolbarData: {
          'hamburgerShow': false,

          'images': [],
          'forms': [],
          'datasets': [],

          'zoomLevel': 1,
          'zoomLevelInv': 0,

          'pageCurrent': 1,
          'pageTotal': 1,

          'fieldLowestpx': 0,

          'explorerShow': false,
          'explorerPage': '',

          'saveFileShow': false,
          'saveFileName': '',
        },

        editorData: {
          'pageOffsetX': 0,
          'pageOffsetY': 0,

          'pageSel': null,
          'fieldSel': null,

          'pageEditorShow': false,

          'newFieldShow': false,
          'newFieldPosX': 0,
          'newFieldPosY': 0,
        },

        mouseData: {
          'editorResizeMouseDown': false,
          'editorResizeType': '',


          'pagerMouseDown': false,
          'pagerMouseOver': false,
          'pagerMouseMove': false,
          'pagerMousePosX': 0,
          'pagerMousePosY': 0,

          'pagerScrollTop': 0,
          'pagerScrollLeft': 0,
        },

        //-- Referenced Default data (ALL px sizing refers to IF the DPI for printing is at 96DPI)
        pageData: {
          'version': 2,
          'widthpx': 794,
          'heightpx': 1123,
          'widthmm': 210,
          'heightmm': 297,
          'fontptpx': 1.3,
          'selection': 'A4',
          'dataset': '',
        },

        pageDefault: {
          'A4': {
            'version': 2,
            'id': 0,
            'image': '',
            'properties': {
              'default': true,
              'widthpx': 794,
              'heightpx': 1123,
              'widthmm': 210,
              'heightmm': 297,
            },
          },
          'Letter': {
            'version': 2,
            'id': 0,
            'image': '',
            'properties': {
              'default': true,
              'widthpx': 816,
              'heightpx': 1056,
              'widthmm': 215.9,
              'heightmm': 279.4,
            },
          },
        },

        fieldDefault: {
          'text': {
            'version': 2,
            'id': 0,
            'posX1': 0,
            'posY1': 0,
            'posX2': 100,
            'posY2': 80,
            'type': 'text',
            'properties': {
              'default': true,
              'overflow': false,
              'focus': false,
              'selected': false,
              'border': false,
              'value': '',
              'fontFamily': 'Arial, sans-serif',
              'fontSize': 11,
              'fontWeight': 'normal',
              'fontJustify': 'left',
              'fontOverflow': true,
            },
          },
          'table': {
            'version': 2,
            'id': 0,
            'posX1': 0,
            'posY1': 0,
            'posX2': 200,
            'posY2': 100,
            'type': 'table',
            'properties': {
              'default': true,
              'overflow': false,
              'focus': false,
              'selected': false,
              'border': false,
              'autoGenerate': false,
              'itemKey': 'Test',
              'numInd': 0,
              'numCol': 3,
              'numRow': 4,
              'columns': [],
              'cellDefault': {
                'id': '',
                'value': '',
                'valueIndex': 0,
                'fontFamily': 'Arial, sans-serif',
                'fontSize': 11,
                'fontWeight': 'normal',
                'fontJustify': 'left',
                'fontOverflow': true,
              }
            },
          },
          'tsmanifest': {
            'version': 2,
            'id': 0,
            'posX1': 0,
            'posY1': 0,
            'posX2': 816,
            'posY2': 1056,
            'type': 'tsmanifest',
            'properties': {
              'default': true,
              'overflow': true,
              'focus': false,
              'selected': false,
              'jobs': [],
              'details': null,
            },
          },
          'consignment': {
            'version': 2,
            'id': 0,
            'posX1': 0,
            'posY1': 0,
            'posX2': 816,
            'posY2': 1056,
            'type': '',
            'properties': {
              'default': true,
              'overflow': true,
              'focus': false,
              'selected': false,
              'cns': null,
              'details': null,
            },
          },
        },

        fieldColors: {
          'text': { 'BGColor': '#0b872222', 'BDColor': '#0b8722' },
          'table': { 'BGColor': '#3ec3f022', 'BDColor': '#3ec3f0' },
          'tsmanifest': { 'BGColor': '#ffd45e22', 'BDColor': '#ffd45e' },
        },

        icon: {
          'hamburger': 'M100 125L400 125L400 145L100 145L100 125Z M100 355L400 355L400 375L100 375L100 355Z M100 240L400 240L400 260L100 260L100 240Z',
          'grid': '',
          // 'grid': 'M0 0L0 2970ZM10 0L10 2970ZM20 0L20 2970ZM30 0L30 2970ZM40 0L40 2970ZM50 0L50 2970ZM60 0L60 2970ZM70 0L70 2970ZM80 0L80 2970ZM90 0L90 2970ZM100 0L100 2970ZM110 0L110 2970ZM120 0L120 2970ZM130 0L130 2970ZM140 0L140 2970ZM150 0L150 2970ZM160 0L160 2970ZM170 0L170 2970ZM180 0L180 2970ZM190 0L190 2970ZM200 0L200 2970ZM210 0L210 2970ZM220 0L220 2970ZM230 0L230 2970ZM240 0L240 2970ZM250 0L250 2970ZM260 0L260 2970ZM270 0L270 2970ZM280 0L280 2970ZM290 0L290 2970ZM300 0L300 2970ZM310 0L310 2970ZM320 0L320 2970ZM330 0L330 2970ZM340 0L340 2970ZM350 0L350 2970ZM360 0L360 2970ZM370 0L370 2970ZM380 0L380 2970ZM390 0L390 2970ZM400 0L400 2970ZM410 0L410 2970ZM420 0L420 2970ZM430 0L430 2970ZM440 0L440 2970ZM450 0L450 2970ZM460 0L460 2970ZM470 0L470 2970ZM480 0L480 2970ZM490 0L490 2970ZM500 0L500 2970ZM510 0L510 2970ZM520 0L520 2970ZM530 0L530 2970ZM540 0L540 2970ZM550 0L550 2970ZM560 0L560 2970ZM570 0L570 2970ZM580 0L580 2970ZM590 0L590 2970ZM600 0L600 2970ZM610 0L610 2970ZM620 0L620 2970ZM630 0L630 2970ZM640 0L640 2970ZM650 0L650 2970ZM660 0L660 2970ZM670 0L670 2970ZM680 0L680 2970ZM690 0L690 2970ZM700 0L700 2970ZM710 0L710 2970ZM720 0L720 2970ZM730 0L730 2970ZM740 0L740 2970ZM750 0L750 2970ZM760 0L760 2970ZM770 0L770 2970ZM780 0L780 2970ZM790 0L790 2970ZM800 0L800 2970ZM810 0L810 2970ZM820 0L820 2970ZM830 0L830 2970ZM840 0L840 2970ZM850 0L850 2970ZM860 0L860 2970ZM870 0L870 2970ZM880 0L880 2970ZM890 0L890 2970ZM900 0L900 2970ZM910 0L910 2970ZM920 0L920 2970ZM930 0L930 2970ZM940 0L940 2970ZM950 0L950 2970ZM960 0L960 2970ZM970 0L970 2970ZM980 0L980 2970ZM990 0L990 2970ZM1000 0L1000 2970ZM1010 0L1010 2970ZM1020 0L1020 2970ZM1030 0L1030 2970ZM1040 0L1040 2970ZM1050 0L1050 2970ZM1060 0L1060 2970ZM1070 0L1070 2970ZM1080 0L1080 2970ZM1090 0L1090 2970ZM1100 0L1100 2970ZM1110 0L1110 2970ZM1120 0L1120 2970ZM1130 0L1130 2970ZM1140 0L1140 2970ZM1150 0L1150 2970ZM1160 0L1160 2970ZM1170 0L1170 2970ZM1180 0L1180 2970ZM1190 0L1190 2970ZM1200 0L1200 2970ZM1210 0L1210 2970ZM1220 0L1220 2970ZM1230 0L1230 2970ZM1240 0L1240 2970ZM1250 0L1250 2970ZM1260 0L1260 2970ZM1270 0L1270 2970ZM1280 0L1280 2970ZM1290 0L1290 2970ZM1300 0L1300 2970ZM1310 0L1310 2970ZM1320 0L1320 2970ZM1330 0L1330 2970ZM1340 0L1340 2970ZM1350 0L1350 2970ZM1360 0L1360 2970ZM1370 0L1370 2970ZM1380 0L1380 2970ZM1390 0L1390 2970ZM1400 0L1400 2970ZM1410 0L1410 2970ZM1420 0L1420 2970ZM1430 0L1430 2970ZM1440 0L1440 2970ZM1450 0L1450 2970ZM1460 0L1460 2970ZM1470 0L1470 2970ZM1480 0L1480 2970ZM1490 0L1490 2970ZM1500 0L1500 2970ZM1510 0L1510 2970ZM1520 0L1520 2970ZM1530 0L1530 2970ZM1540 0L1540 2970ZM1550 0L1550 2970ZM1560 0L1560 2970ZM1570 0L1570 2970ZM1580 0L1580 2970ZM1590 0L1590 2970ZM1600 0L1600 2970ZM1610 0L1610 2970ZM1620 0L1620 2970ZM1630 0L1630 2970ZM1640 0L1640 2970ZM1650 0L1650 2970ZM1660 0L1660 2970ZM1670 0L1670 2970ZM1680 0L1680 2970ZM1690 0L1690 2970ZM1700 0L1700 2970ZM1710 0L1710 2970ZM1720 0L1720 2970ZM1730 0L1730 2970ZM1740 0L1740 2970ZM1750 0L1750 2970ZM1760 0L1760 2970ZM1770 0L1770 2970ZM1780 0L1780 2970ZM1790 0L1790 2970ZM1800 0L1800 2970ZM1810 0L1810 2970ZM1820 0L1820 2970ZM1830 0L1830 2970ZM1840 0L1840 2970ZM1850 0L1850 2970ZM1860 0L1860 2970ZM1870 0L1870 2970ZM1880 0L1880 2970ZM1890 0L1890 2970ZM1900 0L1900 2970ZM1910 0L1910 2970ZM1920 0L1920 2970ZM1930 0L1930 2970ZM1940 0L1940 2970ZM1950 0L1950 2970ZM1960 0L1960 2970ZM1970 0L1970 2970ZM1980 0L1980 2970ZM1990 0L1990 2970ZM2000 0L2000 2970ZM2010 0L2010 2970ZM2020 0L2020 2970ZM2030 0L2030 2970ZM2040 0L2040 2970ZM2050 0L2050 2970ZM2060 0L2060 2970ZM2070 0L2070 2970ZM2080 0L2080 2970ZM2090 0L2090 2970ZM2100 0L2100 2970ZM0 0L2100 0ZM0 10L2100 10ZM0 20L2100 20ZM0 30L2100 30ZM0 40L2100 40ZM0 50L2100 50ZM0 60L2100 60ZM0 70L2100 70ZM0 80L2100 80ZM0 90L2100 90ZM0 100L2100 100ZM0 110L2100 110ZM0 120L2100 120ZM0 130L2100 130ZM0 140L2100 140ZM0 150L2100 150ZM0 160L2100 160ZM0 170L2100 170ZM0 180L2100 180ZM0 190L2100 190ZM0 200L2100 200ZM0 210L2100 210ZM0 220L2100 220ZM0 230L2100 230ZM0 240L2100 240ZM0 250L2100 250ZM0 260L2100 260ZM0 270L2100 270ZM0 280L2100 280ZM0 290L2100 290ZM0 300L2100 300ZM0 310L2100 310ZM0 320L2100 320ZM0 330L2100 330ZM0 340L2100 340ZM0 350L2100 350ZM0 360L2100 360ZM0 370L2100 370ZM0 380L2100 380ZM0 390L2100 390ZM0 400L2100 400ZM0 410L2100 410ZM0 420L2100 420ZM0 430L2100 430ZM0 440L2100 440ZM0 450L2100 450ZM0 460L2100 460ZM0 470L2100 470ZM0 480L2100 480ZM0 490L2100 490ZM0 500L2100 500ZM0 510L2100 510ZM0 520L2100 520ZM0 530L2100 530ZM0 540L2100 540ZM0 550L2100 550ZM0 560L2100 560ZM0 570L2100 570ZM0 580L2100 580ZM0 590L2100 590ZM0 600L2100 600ZM0 610L2100 610ZM0 620L2100 620ZM0 630L2100 630ZM0 640L2100 640ZM0 650L2100 650ZM0 660L2100 660ZM0 670L2100 670ZM0 680L2100 680ZM0 690L2100 690ZM0 700L2100 700ZM0 710L2100 710ZM0 720L2100 720ZM0 730L2100 730ZM0 740L2100 740ZM0 750L2100 750ZM0 760L2100 760ZM0 770L2100 770ZM0 780L2100 780ZM0 790L2100 790ZM0 800L2100 800ZM0 810L2100 810ZM0 820L2100 820ZM0 830L2100 830ZM0 840L2100 840ZM0 850L2100 850ZM0 860L2100 860ZM0 870L2100 870ZM0 880L2100 880ZM0 890L2100 890ZM0 900L2100 900ZM0 910L2100 910ZM0 920L2100 920ZM0 930L2100 930ZM0 940L2100 940ZM0 950L2100 950ZM0 960L2100 960ZM0 970L2100 970ZM0 980L2100 980ZM0 990L2100 990ZM0 1000L2100 1000ZM0 1010L2100 1010ZM0 1020L2100 1020ZM0 1030L2100 1030ZM0 1040L2100 1040ZM0 1050L2100 1050ZM0 1060L2100 1060ZM0 1070L2100 1070ZM0 1080L2100 1080ZM0 1090L2100 1090ZM0 1100L2100 1100ZM0 1110L2100 1110ZM0 1120L2100 1120ZM0 1130L2100 1130ZM0 1140L2100 1140ZM0 1150L2100 1150ZM0 1160L2100 1160ZM0 1170L2100 1170ZM0 1180L2100 1180ZM0 1190L2100 1190ZM0 1200L2100 1200ZM0 1210L2100 1210ZM0 1220L2100 1220ZM0 1230L2100 1230ZM0 1240L2100 1240ZM0 1250L2100 1250ZM0 1260L2100 1260ZM0 1270L2100 1270ZM0 1280L2100 1280ZM0 1290L2100 1290ZM0 1300L2100 1300ZM0 1310L2100 1310ZM0 1320L2100 1320ZM0 1330L2100 1330ZM0 1340L2100 1340ZM0 1350L2100 1350ZM0 1360L2100 1360ZM0 1370L2100 1370ZM0 1380L2100 1380ZM0 1390L2100 1390ZM0 1400L2100 1400ZM0 1410L2100 1410ZM0 1420L2100 1420ZM0 1430L2100 1430ZM0 1440L2100 1440ZM0 1450L2100 1450ZM0 1460L2100 1460ZM0 1470L2100 1470ZM0 1480L2100 1480ZM0 1490L2100 1490ZM0 1500L2100 1500ZM0 1510L2100 1510ZM0 1520L2100 1520ZM0 1530L2100 1530ZM0 1540L2100 1540ZM0 1550L2100 1550ZM0 1560L2100 1560ZM0 1570L2100 1570ZM0 1580L2100 1580ZM0 1590L2100 1590ZM0 1600L2100 1600ZM0 1610L2100 1610ZM0 1620L2100 1620ZM0 1630L2100 1630ZM0 1640L2100 1640ZM0 1650L2100 1650ZM0 1660L2100 1660ZM0 1670L2100 1670ZM0 1680L2100 1680ZM0 1690L2100 1690ZM0 1700L2100 1700ZM0 1710L2100 1710ZM0 1720L2100 1720ZM0 1730L2100 1730ZM0 1740L2100 1740ZM0 1750L2100 1750ZM0 1760L2100 1760ZM0 1770L2100 1770ZM0 1780L2100 1780ZM0 1790L2100 1790ZM0 1800L2100 1800ZM0 1810L2100 1810ZM0 1820L2100 1820ZM0 1830L2100 1830ZM0 1840L2100 1840ZM0 1850L2100 1850ZM0 1860L2100 1860ZM0 1870L2100 1870ZM0 1880L2100 1880ZM0 1890L2100 1890ZM0 1900L2100 1900ZM0 1910L2100 1910ZM0 1920L2100 1920ZM0 1930L2100 1930ZM0 1940L2100 1940ZM0 1950L2100 1950ZM0 1960L2100 1960ZM0 1970L2100 1970ZM0 1980L2100 1980ZM0 1990L2100 1990ZM0 2000L2100 2000ZM0 2010L2100 2010ZM0 2020L2100 2020ZM0 2030L2100 2030ZM0 2040L2100 2040ZM0 2050L2100 2050ZM0 2060L2100 2060ZM0 2070L2100 2070ZM0 2080L2100 2080ZM0 2090L2100 2090ZM0 2100L2100 2100ZM0 2110L2100 2110ZM0 2120L2100 2120ZM0 2130L2100 2130ZM0 2140L2100 2140ZM0 2150L2100 2150ZM0 2160L2100 2160ZM0 2170L2100 2170ZM0 2180L2100 2180ZM0 2190L2100 2190ZM0 2200L2100 2200ZM0 2210L2100 2210ZM0 2220L2100 2220ZM0 2230L2100 2230ZM0 2240L2100 2240ZM0 2250L2100 2250ZM0 2260L2100 2260ZM0 2270L2100 2270ZM0 2280L2100 2280ZM0 2290L2100 2290ZM0 2300L2100 2300ZM0 2310L2100 2310ZM0 2320L2100 2320ZM0 2330L2100 2330ZM0 2340L2100 2340ZM0 2350L2100 2350ZM0 2360L2100 2360ZM0 2370L2100 2370ZM0 2380L2100 2380ZM0 2390L2100 2390ZM0 2400L2100 2400ZM0 2410L2100 2410ZM0 2420L2100 2420ZM0 2430L2100 2430ZM0 2440L2100 2440ZM0 2450L2100 2450ZM0 2460L2100 2460ZM0 2470L2100 2470ZM0 2480L2100 2480ZM0 2490L2100 2490ZM0 2500L2100 2500ZM0 2510L2100 2510ZM0 2520L2100 2520ZM0 2530L2100 2530ZM0 2540L2100 2540ZM0 2550L2100 2550ZM0 2560L2100 2560ZM0 2570L2100 2570ZM0 2580L2100 2580ZM0 2590L2100 2590ZM0 2600L2100 2600ZM0 2610L2100 2610ZM0 2620L2100 2620ZM0 2630L2100 2630ZM0 2640L2100 2640ZM0 2650L2100 2650ZM0 2660L2100 2660ZM0 2670L2100 2670ZM0 2680L2100 2680ZM0 2690L2100 2690ZM0 2700L2100 2700ZM0 2710L2100 2710ZM0 2720L2100 2720ZM0 2730L2100 2730ZM0 2740L2100 2740ZM0 2750L2100 2750ZM0 2760L2100 2760ZM0 2770L2100 2770ZM0 2780L2100 2780ZM0 2790L2100 2790ZM0 2800L2100 2800ZM0 2810L2100 2810ZM0 2820L2100 2820ZM0 2830L2100 2830ZM0 2840L2100 2840ZM0 2850L2100 2850ZM0 2860L2100 2860ZM0 2870L2100 2870ZM0 2880L2100 2880ZM0 2890L2100 2890ZM0 2900L2100 2900ZM0 2910L2100 2910ZM0 2920L2100 2920ZM0 2930L2100 2930ZM0 2940L2100 2940ZM0 2950L2100 2950ZM0 2960L2100 2960ZM0 2970L2100 2970Z',
          //'grid': 'M0 0L2100 0ZM0 10L2100 10ZM0 20L2100 20ZM0 30L2100 30ZM0 40L2100 40ZM0 50L2100 50ZM0 60L2100 60ZM0 70L2100 70ZM0 80L2100 80ZM0 90L2100 90ZM0 100L2100 100ZM0 110L2100 110ZM0 120L2100 120ZM0 130L2100 130ZM0 140L2100 140ZM0 150L2100 150ZM0 160L2100 160ZM0 170L2100 170ZM0 180L2100 180ZM0 190L2100 190ZM0 200L2100 200ZM0 210L2100 210ZM0 220L2100 220ZM0 230L2100 230ZM0 240L2100 240ZM0 250L2100 250ZM0 260L2100 260ZM0 270L2100 270ZM0 280L2100 280ZM0 290L2100 290ZM0 300L2100 300ZM0 310L2100 310ZM0 320L2100 320ZM0 330L2100 330ZM0 340L2100 340ZM0 350L2100 350ZM0 360L2100 360ZM0 370L2100 370ZM0 380L2100 380ZM0 390L2100 390ZM0 400L2100 400ZM0 410L2100 410ZM0 420L2100 420ZM0 430L2100 430ZM0 440L2100 440ZM0 450L2100 450ZM0 460L2100 460ZM0 470L2100 470ZM0 480L2100 480ZM0 490L2100 490ZM0 500L2100 500ZM0 510L2100 510ZM0 520L2100 520ZM0 530L2100 530ZM0 540L2100 540ZM0 550L2100 550ZM0 560L2100 560ZM0 570L2100 570ZM0 580L2100 580ZM0 590L2100 590ZM0 600L2100 600ZM0 610L2100 610ZM0 620L2100 620ZM0 630L2100 630ZM0 640L2100 640ZM0 650L2100 650ZM0 660L2100 660ZM0 670L2100 670ZM0 680L2100 680ZM0 690L2100 690ZM0 700L2100 700ZM0 710L2100 710ZM0 720L2100 720ZM0 730L2100 730ZM0 740L2100 740ZM0 750L2100 750ZM0 760L2100 760ZM0 770L2100 770ZM0 780L2100 780ZM0 790L2100 790ZM0 800L2100 800ZM0 810L2100 810ZM0 820L2100 820ZM0 830L2100 830ZM0 840L2100 840ZM0 850L2100 850ZM0 860L2100 860ZM0 870L2100 870ZM0 880L2100 880ZM0 890L2100 890ZM0 900L2100 900ZM0 910L2100 910ZM0 920L2100 920ZM0 930L2100 930ZM0 940L2100 940ZM0 950L2100 950ZM0 960L2100 960ZM0 970L2100 970ZM0 980L2100 980ZM0 990L2100 990ZM0 1000L2100 1000ZM0 1010L2100 1010ZM0 1020L2100 1020ZM0 1030L2100 1030ZM0 1040L2100 1040ZM0 1050L2100 1050ZM0 1060L2100 1060ZM0 1070L2100 1070ZM0 1080L2100 1080ZM0 1090L2100 1090ZM0 1100L2100 1100ZM0 1110L2100 1110ZM0 1120L2100 1120ZM0 1130L2100 1130ZM0 1140L2100 1140ZM0 1150L2100 1150ZM0 1160L2100 1160ZM0 1170L2100 1170ZM0 1180L2100 1180ZM0 1190L2100 1190ZM0 1200L2100 1200ZM0 1210L2100 1210ZM0 1220L2100 1220ZM0 1230L2100 1230ZM0 1240L2100 1240ZM0 1250L2100 1250ZM0 1260L2100 1260ZM0 1270L2100 1270ZM0 1280L2100 1280ZM0 1290L2100 1290ZM0 1300L2100 1300ZM0 1310L2100 1310ZM0 1320L2100 1320ZM0 1330L2100 1330ZM0 1340L2100 1340ZM0 1350L2100 1350ZM0 1360L2100 1360ZM0 1370L2100 1370ZM0 1380L2100 1380ZM0 1390L2100 1390ZM0 1400L2100 1400ZM0 1410L2100 1410ZM0 1420L2100 1420ZM0 1430L2100 1430ZM0 1440L2100 1440ZM0 1450L2100 1450ZM0 1460L2100 1460ZM0 1470L2100 1470ZM0 1480L2100 1480ZM0 1490L2100 1490ZM0 1500L2100 1500ZM0 1510L2100 1510ZM0 1520L2100 1520ZM0 1530L2100 1530ZM0 1540L2100 1540ZM0 1550L2100 1550ZM0 1560L2100 1560ZM0 1570L2100 1570ZM0 1580L2100 1580ZM0 1590L2100 1590ZM0 1600L2100 1600ZM0 1610L2100 1610ZM0 1620L2100 1620ZM0 1630L2100 1630ZM0 1640L2100 1640ZM0 1650L2100 1650ZM0 1660L2100 1660ZM0 1670L2100 1670ZM0 1680L2100 1680ZM0 1690L2100 1690ZM0 1700L2100 1700ZM0 1710L2100 1710ZM0 1720L2100 1720ZM0 1730L2100 1730ZM0 1740L2100 1740ZM0 1750L2100 1750ZM0 1760L2100 1760ZM0 1770L2100 1770ZM0 1780L2100 1780ZM0 1790L2100 1790ZM0 1800L2100 1800ZM0 1810L2100 1810ZM0 1820L2100 1820ZM0 1830L2100 1830ZM0 1840L2100 1840ZM0 1850L2100 1850ZM0 1860L2100 1860ZM0 1870L2100 1870ZM0 1880L2100 1880ZM0 1890L2100 1890ZM0 1900L2100 1900ZM0 1910L2100 1910ZM0 1920L2100 1920ZM0 1930L2100 1930ZM0 1940L2100 1940ZM0 1950L2100 1950ZM0 1960L2100 1960ZM0 1970L2100 1970ZM0 1980L2100 1980ZM0 1990L2100 1990ZM0 2000L2100 2000ZM0 2010L2100 2010ZM0 2020L2100 2020ZM0 2030L2100 2030ZM0 2040L2100 2040ZM0 2050L2100 2050ZM0 2060L2100 2060ZM0 2070L2100 2070ZM0 2080L2100 2080ZM0 2090L2100 2090ZM0 2100L2100 2100ZM0 2110L2100 2110ZM0 2120L2100 2120ZM0 2130L2100 2130ZM0 2140L2100 2140ZM0 2150L2100 2150ZM0 2160L2100 2160ZM0 2170L2100 2170ZM0 2180L2100 2180ZM0 2190L2100 2190ZM0 2200L2100 2200ZM0 2210L2100 2210ZM0 2220L2100 2220ZM0 2230L2100 2230ZM0 2240L2100 2240ZM0 2250L2100 2250ZM0 2260L2100 2260ZM0 2270L2100 2270ZM0 2280L2100 2280ZM0 2290L2100 2290ZM0 2300L2100 2300ZM0 2310L2100 2310ZM0 2320L2100 2320ZM0 2330L2100 2330ZM0 2340L2100 2340ZM0 2350L2100 2350ZM0 2360L2100 2360ZM0 2370L2100 2370ZM0 2380L2100 2380ZM0 2390L2100 2390ZM0 2400L2100 2400ZM0 2410L2100 2410ZM0 2420L2100 2420ZM0 2430L2100 2430ZM0 2440L2100 2440ZM0 2450L2100 2450ZM0 2460L2100 2460ZM0 2470L2100 2470ZM0 2480L2100 2480ZM0 2490L2100 2490ZM0 2500L2100 2500ZM0 2510L2100 2510ZM0 2520L2100 2520ZM0 2530L2100 2530ZM0 2540L2100 2540ZM0 2550L2100 2550ZM0 2560L2100 2560ZM0 2570L2100 2570ZM0 2580L2100 2580ZM0 2590L2100 2590ZM0 2600L2100 2600ZM0 2610L2100 2610ZM0 2620L2100 2620ZM0 2630L2100 2630ZM0 2640L2100 2640ZM0 2650L2100 2650ZM0 2660L2100 2660ZM0 2670L2100 2670ZM0 2680L2100 2680ZM0 2690L2100 2690ZM0 2700L2100 2700ZM0 2710L2100 2710ZM0 2720L2100 2720ZM0 2730L2100 2730ZM0 2740L2100 2740ZM0 2750L2100 2750ZM0 2760L2100 2760ZM0 2770L2100 2770ZM0 2780L2100 2780ZM0 2790L2100 2790ZM0 2800L2100 2800ZM0 2810L2100 2810ZM0 2820L2100 2820ZM0 2830L2100 2830ZM0 2840L2100 2840ZM0 2850L2100 2850ZM0 2860L2100 2860ZM0 2870L2100 2870ZM0 2880L2100 2880ZM0 2890L2100 2890ZM0 2900L2100 2900ZM0 2910L2100 2910ZM0 2920L2100 2920ZM0 2930L2100 2930ZM0 2940L2100 2940ZM0 2950L2100 2950ZM0 2960L2100 2960ZM0 2970L2100 2970Z',

          'minus': 'M100 240L400 240L400 260L100 260L100 240Z',
          'plus': 'M100 240L400 240L400 260L100 260L100 240Z M260 100L260 400L240 400L240 100L260 100Z',
          'downarrow': 'M400 254.41L250 400L100 254.41L195.09 254.41L195.09 100L305.15 100L305.15 254.41L400 254.41Z',
          'uparrow': 'M100 245.59L250 100L400 245.59L304.91 245.59L304.91 400L194.85 400L194.85 245.59L100 245.59Z',

          'pagebreak': 'M158.34 500L800 500L800 0L158.34 0L0 250L158.34 500Z',

          'alignT': 'M50 195L50 190L450 190L450 195L50 195ZM50 125L50 120L450 120L450 125L50 125ZM50 55L50 50L450 50L450 55L50 55Z',
          'alignC': 'M50 322.5L50 317.5L450 317.5L450 322.5L50 322.5ZM50 252.5L50 247.5L450 247.5L450 252.5L50 252.5ZM50 182.5L50 177.5L450 177.5L450 182.5L50 182.5Z',
          'alignB': 'M50 450L50 445L450 445L450 450L50 450ZM50 380L50 375L450 375L450 380L50 380ZM50 310L50 305L450 305L450 310L50 310Z',
            
          'justifyL': 'M50 250L450 250L450 270L50 270L50 250Z M50 130L230 130L230 150L50 150L50 130Z M50 370L330 370L330 390L50 390L50 370Z',
          'justifyC': 'M50 250L450 250L450 270L50 270L50 250Z M50 130L450 130L450 150L50 150L50 130Z M50 370L450 370L450 390L50 390L50 370Z',
          'justifyR': 'M50 250L450 250L450 270L50 270L50 250Z M270 130L450 130L450 150L270 150L270 130Z M170 370L450 370L450 390L170 390L170 370Z',
      
          'border': 'M240 450L240 440L320 440L320 450L240 450ZM60 60L60 450L50 450L50 50L450 50L450 60L60 60ZM110 450L110 440L190 440L190 450L110 450ZM370 450L370 440L440 440L440 368.1L450 368.1L450 450L370 450ZM440 320L440 240L450 240L450 320L440 320ZM440 190L440 110L450 110L450 190L440 190Z',
          'overflow': 'M405 100L400 100L400 55L55 55L55 400L100 400L100 405L50 405L50 50L405 50L405 100ZM150 355L150 350L450 350L450 355L150 355ZM150 260L150 255L450 255L450 260L150 260ZM150 165L150 160L450 160L450 165L150 165Z',
          'copy': 'M50 107.14L392.86 107.14L392.86 450L50 450L50 107.14Z M450 392.86L450 50L107.14 50 M50 107.14L392.86 107.14L392.86 450L50 450L50 107.14Z',
        }
      }
    },
    computed: {

    },
    mounted() {
      this.loadData();
    },
    beforeDestroy() {
      
    },
    methods: {
      //---- Main Methods
      loadData: async function() {
        //---- Set variables
        var pagerDOM = this.$refs['pagerMain'];
        var pageDOM = this.$refs['pageMain'];
        
        //-- Get initial zoom level
        this.loadDefaultSize();

        //-- Get total pages
        this.$nextTick(() => { this.pagerCheckOverflow(); });
        
        //-- Get data
        try { // Images
          var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTimage');
          if (Array.isArray(request)) { this.$set(this.toolbarData, 'images', request); }
        } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request); };
        try { // JSONs
          var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTform');
          if (Array.isArray(request)) { this.$set(this.toolbarData, 'forms', request); }
        } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request); };
        try { // Datasets
          var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ReportKeys');
          if (Array.isArray(request)) { this.$set(this.toolbarData, 'datasets', request); }
        } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request); };

        //-- Some listeners
        window.addEventListener('keydown', (e) => { this.winKeyDown(e) });

        //-- Load Images
        this.loadImg();

        //-- Check for Changes etc for data and form (checks overflow etc)
        this.dataChange();
        this.formChange();
        this.sizeChange();

        //---- Generate extra pages for auto generate feature on Table fields
        var formJson = await this.$apiCallV2('/ReportDesigner/ReadFiles?folderPath=ROTform&fileName=' + this.mainData['form']);
        var hasAutoGenerateTable = formJson['data']['fields'].some(t => t['type'] == "table" && t['properties']['autoGenerate'] == true);
        if (hasAutoGenerateTable) { this.pageAutoGenerate(); }

        //-- Disable default button keys for Browsers
        $(function(){   
          $(document).keydown(function(e) {
            // console.log(e);
            //-- Disable some buttons when a field is in focus
            // if (e['keyCode'] == 9) {           
            //     e.preventDefault();
            //     return false;
            // }
            
            //-- Events that have Ctrl Key pressed
            if (e['ctrlKey']) {          
              //-- Prevents default Ctrl + A
              switch(e['keyCode']) {
                case 65:
                case 83:
                  e.preventDefault();
                  break;
              }

            //-- Events that have Shift Key pressed               
            } else if (e['shiftKey']) {

              
            //-- Events that have Alt Key pressed    
            } else if (e['altKey']) {
              
            }
          });
        });

        //-- Loaded
        setTimeout(() => { this.$set(this.mainData, 'loaded', true); }, 500); 
      },
      loadImg: async function() {
        // console.log('Img Load');
        this.mainData['pages'].forEach(async (p) => {
          var imageDOM = document.getElementById('pageBreak' + p['id']);

          if (p['image']) {
            try {
              var request = await this.$apiCallV2('/ReportDesigner/ReadImage?folderPath=ROTimage&fileName=' + p['image']);
              this.$nextTick(() => { imageDOM['style']['backgroundImage'] = 'url(\'data:image/png;base64,' + request + '\')'; });
            } catch(e) { console.log(e); }
          } else {
            this.$nextTick(() => { imageDOM['style']['backgroundImage'] = ''; });
          }
        });
      },
      loadForm: async function() {
        var request = await this.$apiCallV2('/ReportDesigner/ReadFiles?folderPath=ROTform&fileName=' + this.mainData['form']);
        // console.log('%cForm Load', 'color: hotpink;', request['data']);
        // console.log('%cForm Load', 'color: hotpink;', request);
        //-- HAS LEGACY SUPPORT 
        if (!Array.isArray(request['data']) && (typeof request['data'] == 'object')) {
          this.$set(this.pageData, 'selection', request['data']['page'] ? request['data']['page']['selection'] : 'A4');
          this.$set(this.mainData, 'pages', request['data']['pages']);
          this.$set(this.mainData, 'fields', request['data']['fields']);

          //-- Reconfigure
          this.$nextTick(() => { 
            this.loadImg();
            this.sizeChange();
          });
        } else if (Array.isArray(request['data'])) {
          this.$set(this.mainData, 'pages', []);
          this.$set(this.mainData, 'fields', []);

          request['data'].forEach((f, i) => {
            // console.log('%cVersion', 'color: yellow;', f['version'] ? f['version'] : 'Unknown');
            switch(f['version']) {
              case 1:
                var pageObj = JSON.parse(JSON.stringify(this.pageDefault['A4']));

                //-- Set page settings
                this.$set(pageObj, 'image', f['form'] ? f['form'].trim() : '');
                
                //-- Push page
                this.mainData['pages'].push(pageObj);

                //-- Get fields
                if (f['fields'] && f['fields']['length'] > 0) {
                  f['fields'].forEach((f2, i2) => {
                    switch(f2['properties']['type']) {
                      case 'text':
                        var textProperties = {
                          'posX1': f2['posX'] + 1,
                          'posY1': f2['posY'] - 0,
                          'posX2': (f2['posX'] + f2['width']) + 1,
                          'posY2': (f2['posY'] + f2['height']) - 0,

                          'fontFamily': 'Arial, sans-serif',
                          'fontSize': parseInt(f2['properties']['textSize']),
                          'fontWeight': f2['properties']['textWeight'],
                          'fontJustify': f2['properties']['textJustify'],
                          'fontOverflow': true,

                          'value': f2['properties']['value'],
                        }
                        
                        if (i2 == 0) {
                          // console.log(f2);
                          // console.log(f2['properties']);
                        }
                        
                        this.fieldNew('text', textProperties, null)
                        break;
                      case 'table':
                        var tableProperties = {
                          'posX1': f2['posX'] + 1,
                          'posY1': f2['posY'] - 0,
                          'posX2': (f2['posX'] + f2['width']) + 1,
                          'posY2': (f2['posY'] + f2['height']) - 0,

                          'fontFamily': 'Arial, sans-serif',
                          'fontSize': parseInt(f2['properties']['textSize']),
                          'fontWeight': f2['properties']['textWeight'],
                          'fontJustify': f2['properties']['textJustify'],
                          'fontOverflow': true,

                          'value': '{' + JSON.parse(f2['properties']['value'])['key'] + '}',
                          'itemKey': f2['properties']['tableKey'],

                          'numInd': (parseInt(f2['properties']['tableSeq']) - 1),
                          'numCol': parseInt(f2['properties']['tableCol']),
                          'numRow': parseInt(f2['properties']['tableRow']),

                          'border': f2['properties']['tableBorder'],
                        }

                        // console.log(f2);

                        this.fieldNew('table', tableProperties, null)
                        break;
                    }
                  });
                }

                //-- Info
                // console.log(pageObj);
                // console.log(f);
                break;
              default:
                this.$set(this.mainData, 'pages', [ JSON.parse(JSON.stringify(this.pageDefault['A4']))]);
                this.$set(this.mainData, 'fields', []);
                break;
            }

            //-- Reconfigure
            this.$nextTick(() => { 
              this.loadImg();
              this.sizeChange();
            });
          });
        }
      },
      loadDefaultSize: async function() {
        //---- Set variables
        var designerDOM = this.$refs['designerMain'];
        var designerWidth = 0;
        
        //-- Get computed styling
        var designerWidth = window.getComputedStyle(designerDOM)['width'];
        if (designerWidth.search('\%') >= 0) {
          var designerRatio = (parseInt(designerWidth.replace('\%', '')) / 100);
          designerWidth = (window['innerWidth'] * designerRatio);

          //-- Get initial zoom level
          this.$set(this.toolbarData, 'zoomLevel', parseFloat(((designerWidth * 0.8) / this.pageDefault[this.pageData['selection']]['properties']['widthpx']).toFixed(1)));
          this.$set(this.toolbarData, 'zoomLevelInv', (1 / this.toolbarData['zoomLevel']));
        } else {
          designerWidth = (parseInt(designerWidth.replace('px', '')));
        }
        
        //-- Set initial zoom level
        this.$set(this.toolbarData, 'zoomLevel', parseFloat(((designerWidth * 0.8) / this.pageDefault[this.pageData['selection']]['properties']['widthpx']).toFixed(1)));
        this.$set(this.toolbarData, 'zoomLevelInv', (1 / this.toolbarData['zoomLevel']));

        // console.log(this.toolbarData['zoomLevel']);
      },
      dataChange: async function() {
        // console.log(this.data);
        this.$set(this.mainData, 'data', this.data);
        this.getOverflow();
      },
      formChange: async function() {
        // console.log(this.form);
        this.$set(this.mainData, 'form', this.form);

        this.$nextTick(() => { this.loadForm(); });
      },
      sizeChange: async function() {
        // console.log(this.pageDefault[this.pageData['selection']]['properties']['widthmm']);
        // console.log(this.pageDefault[this.pageData['selection']]['properties']['heightmm']);
        //---- Set variables
        var pagerDOM = this.$refs['pagerMain'];
        var pageDOM = this.$refs['pageMain'];
        
        //-- Get Page offset relative to body
        setTimeout(() => { 
          this.$set(this.editorData, 'pageOffsetX', pageDOM.getBoundingClientRect()['left'] - pagerDOM.getBoundingClientRect()['left']);
          this.$set(this.editorData, 'pageOffsetY', (pageDOM.getBoundingClientRect()['top'] - pagerDOM.getBoundingClientRect()['top']) + 30);
        }, 1);

        var rows = '';
        for(var i = 0; i < Math.ceil(this.pageDefault[this.pageData['selection']]['properties']['heightmm']); i++) {
          rows += ('M0 ' + (i * 10) + 'L' + (this.pageDefault[this.pageData['selection']]['properties']['widthmm'] * 10) + ' ' + (i * 10) + 'Z');
        }

        var columns = '';
        for(var i = 0; i < Math.ceil(this.pageDefault[this.pageData['selection']]['properties']['widthmm']); i++) {
          columns += ('M' + (i * 10) + ' 0L' + (i * 10) + ' ' + (this.pageDefault[this.pageData['selection']]['properties']['heightmm'] * 10) + 'Z');
        }
        
        this.$set(this.icon, 'grid', rows + columns);
      },

      //---- Error Check Methods
      getTSManifestData(field) {
        var data = {};

        this.$set(data, 'gatepass', field['gatepass'] ? field['gatepass'] : {});
        this.$set(data, 'jobs', field['jobs'] ? field['jobs'] : []);
        // console.log(data);

        return data;
      },

      //---- Listener Methods
      winKeyDown: async function(e) {
        // console.log(e['key']);
        switch(e['key']) {
          case 'Delete':
            if (this.editorData['fieldSel'] && !this.editorData['fieldSel']['properties']['focus']) {
              var fieldIndex = this.mainData['fields'].indexOf(this.editorData['fieldSel']);
              this.mainData['fields'].splice(fieldIndex, 1);

              //-- Reset selected Field
              this.$set(this.editorData, 'fieldSel', null);
            }
            break;
          case 'ArrowUp':
          case 'ArrowDown':
          case 'ArrowLeft':
          case 'ArrowRight':
            if (this.editorData['fieldSel'] && !this.editorData['fieldSel']['properties']['focus']) {
              e.preventDefault();
              var moveDistance = (this.pageDefault[this.pageData['selection']]['properties']['widthpx'] / this.pageDefault[this.pageData['selection']]['properties']['widthmm']);

              //-- Up and Down
              this.$set(this.editorData['fieldSel'], 'posY1', this.editorData['fieldSel']['posY1'] - ((e['key'] == 'ArrowUp') ? moveDistance : ((e['key'] == 'ArrowDown') ? -moveDistance : 0)));
              this.$set(this.editorData['fieldSel'], 'posY2', this.editorData['fieldSel']['posY2'] - ((e['key'] == 'ArrowUp') ? moveDistance : ((e['key'] == 'ArrowDown') ? -moveDistance : 0)));

              //-- Left and Right
              this.$set(this.editorData['fieldSel'], 'posX1', this.editorData['fieldSel']['posX1'] - ((e['key'] == 'ArrowLeft') ? moveDistance : ((e['key'] == 'ArrowRight') ? -moveDistance : 0)));
              this.$set(this.editorData['fieldSel'], 'posX2', this.editorData['fieldSel']['posX2'] - ((e['key'] == 'ArrowLeft') ? moveDistance : ((e['key'] == 'ArrowRight') ? -moveDistance : 0)));
            } 
            break;
          case 's':
            if (e['ctrlKey'] && !this.quickPrint) {
              this.toolbarBtn('save', (this.toolbarData['saveFileShow'] ? '' : 'toggle'));
            }
            break;
        }
      },
      
      //---- Toolbar Methods
      toolbarBtn: async function(cmd, data) {
        var pagerDOM = this.$refs['pagerMain'];
        var pageDOM = this.$refs['pageMain'];

        switch(cmd) {
          case 'hamburger':
            this.$set(this.toolbarData, 'hamburgerShow', data);

            //-- Reset some data
            this.$set(this.editorData, 'pageSel', null);
            if (this.editorData['fieldSel']) {
              this.$set(this.editorData['fieldSel']['properties'], 'selected', false);
              this.$set(this.editorData, 'fieldSel', null);
            }

            //-- Reset New Field Menu
            this.$set(this.editorData, 'newFieldShow', false);
            this.$set(this.editorData, 'newFieldPosX', 0);
            this.$set(this.editorData, 'newFieldPosY', 0);
            break;
          case 'explorer':
            //-- Close the hamburger menu
            this.$set(this.toolbarData, 'hamburgerShow', false);

            switch(data) {
              case 'close':
                // console.log('EXPLORER CLOSED');

                //-- Reload images and forms
                try { // Images
                  var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTimage');
                  if (Array.isArray(request)) { this.$set(this.toolbarData, 'images', request); }
                } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request); };
                try { // JSONs
                  var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ROTform');
                  if (Array.isArray(request)) { this.$set(this.toolbarData, 'forms', request); }
                } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request); };
                try { // Datasets
                  var request = await this.$apiCallV2('/ReportDesigner/GetFiles?folderPath=ReportKeys');
                  if (Array.isArray(request)) { this.$set(this.toolbarData, 'datasets', request); }
                } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', request); };

                //-- Reload dataset on existing tables
                if (this.pageData['dataset']) {
                  var datasetObj = this.toolbarData['datasets'].filter((d, i) => { return ((this.pageData['dataset'] + d['extension']) == d['file']); });
                  // console.log(datasetObj);

                  if (datasetObj['length'] > 0) {
                    var request = await this.$apiCallV2('/ReportDesigner/ReadFiles?folderPath=ReportKeys&fileName=' + datasetObj[0]['file']);
                    // console.log(request);
                    if (typeof request['data'] == 'object') {
                      // this.$emit('update:data', request['data']);
                      this.$set(this.mainData, 'data', request['data']);
                    }
                  } 
                }
                break;
              default:
                this.$set(this.toolbarData, 'explorerShow', true);
                this.$set(this.toolbarData, 'explorerPage', data);
                break;
            }
            break;
          case 'explorerSelect':
            // console.log(data);
            this.$set(this.mainData, 'form', data);

            this.$nextTick(() => { this.loadForm(); });

            //-- Reset selected Field
            this.$set(this.editorData, 'fieldSel', null);
            break;
          case 'save':
            switch (data) {
              case 'toggle':
                this.$set(this.toolbarData, 'saveFileShow', !this.toolbarData['saveFileShow']);
                break;
              case 'save':
                try {
                  var pageProperties = {
                    'selection': this.pageData['selection'],
                  }
                  
                  var request = await this.$apiCallV2('/ReportDesigner/SaveFile?saveType=form&folderPath=ROTform&fileName=' + this.toolbarData['saveFileName'] + '.json', { 'JSON': { 'page': pageProperties, 'pages': this.mainData['pages'], 'fields': this.mainData['fields'] } });
                  // console.log('%cRequest Success', 'color: #00ff00;', request);
                } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', e); }

                this.$set(this.toolbarData, 'saveFileShow', false);
                this.$set(this.toolbarData, 'saveFileName', '');
                break;
            }
            // this.$set(this.toolbarData, 'hamburgerShow', false);
            // console.log('Save Triggered');
            // console.log(data);
            // if (this.toolbarData['saveFileName']) {
            //   try {
            //     var pageProperties = {
            //       'selection': this.pageData['selection'],
            //     }
                
            //     var request = await this.$apiCallV2('/ReportDesigner/SaveFile?saveType=form&folderPath=ROTform&fileName=' + this.toolbarData['saveFileName'] + '.json', { 'JSON': { 'page': pageProperties, 'pages': this.mainData['pages'], 'fields': this.mainData['fields'] } });
            //     console.log('%cRequest Success', 'color: #00ff00;', request);
            //   } catch(e) { console.log('%cRequest Error', 'color: #ff4f38;', e); }

            //   this.$set(this.toolbarData, 'saveFileShow', false);
            //   this.$set(this.toolbarData, 'saveFileName', '');
            // } else {
            //   this.$set(this.toolbarData, 'saveFileShow', true);
            // }
            break;
          case 'editorPage':
            //-- Deselect the selected field
            if (this.editorData['fieldSel']) {
              this.$set(this.editorData['fieldSel']['properties'], 'selected', false);
              this.$set(this.editorData, 'fieldSel', null);
            }

            //-- Check if selected page is same, if true, close the editor
            if (this.editorData['pageSel'] && (this.editorData['pageSel']['id'] == data['id'])) {
              this.$set(this.editorData, 'pageSel', null);
            } else {
              this.$set(this.editorData, 'pageSel', data);

              this.$nextTick(() => {
                var imgSelectDOM = this.$refs['editorPageImg'][0];
                
                this.$set(imgSelectDOM, 'value', data['image']);
              });
            }
            break;
          case 'editorPageImg':
            var imgSelectDOM = this.$refs['editorPageImg'][0];

            this.$set(data, 'image', imgSelectDOM['value']);

            // console.log(data);

            this.$set(this.editorData, 'pageSel', null);
            this.loadImg();
            break;
          case 'editorPageSize':
            var sizeSelectDOM = this.$refs['editorPageSize'][0];

            // console.log(sizeSelectDOM['value']);
            this.$set(this.pageData, 'selection', sizeSelectDOM['value']);

            this.mainData['pages'].forEach((p, i) => {
              this.$set(p['properties'], 'widthpx', this.pageDefault[this.pageData['selection']]['properties']['widthpx']);
              this.$set(p['properties'], 'heightpx', this.pageDefault[this.pageData['selection']]['properties']['heightpx']);
              this.$set(p['properties'], 'widthmm', this.pageDefault[this.pageData['selection']]['properties']['widthmm']);
              this.$set(p['properties'], 'heightmm', this.pageDefault[this.pageData['selection']]['properties']['heightmm']);
            });
            // console.log(this.mainData['pages']);

            this.$nextTick(() => {
              this.sizeChange();
            });
            break;
          case 'editorDataset':
            var datasetSelectDOM = this.$refs['editorDataset'][0];
            // console.log(datasetSelectDOM['value']);
            if (datasetSelectDOM['value']) {
              this.$set(this.pageData, 'dataset', datasetSelectDOM['value']);
              var datasetObj = this.toolbarData['datasets'].filter((d, i) => { return ((datasetSelectDOM['value'] + d['extension']) == d['file']); });
              // console.log(datasetObj);

              if (datasetObj['length'] > 0) {
                var request = await this.$apiCallV2('/ReportDesigner/ReadFiles?folderPath=ReportKeys&fileName=' + datasetObj[0]['file']);
                // console.log(request);
                if (typeof request['data'] == 'object') {
                  // this.$emit('update:data', request['data']);
                  this.$set(this.mainData, 'data', request['data']);
                }
              } 
            }
            break;
          case 'zoomOut':
            this.$set(this.toolbarData, 'zoomLevel', parseFloat((this.toolbarData['zoomLevel'] - (parseFloat((this.toolbarData['zoomLevel'] - 0.1).toFixed(1)) < 0.2 ? 0 : 0.1)).toFixed(1)));
            this.$set(this.toolbarData, 'zoomLevelInv', (1 / this.toolbarData['zoomLevel']));

            setTimeout(() => { this.pagerScroll();}, 1);

            //-- Set the page's offset relative to body
            setTimeout(() => { 
              this.$set(this.editorData, 'pageOffsetX', (pageDOM.getBoundingClientRect()['left'] - pagerDOM.getBoundingClientRect()['left'] + this.mouseData['pagerScrollLeft']));
              this.$set(this.editorData, 'pageOffsetY', ((pageDOM.getBoundingClientRect()['top'] - pagerDOM.getBoundingClientRect()['top']) + this.mouseData['pagerScrollTop']) + 30);
            }, 1);
            break;
          case 'zoomIn':
            this.$set(this.toolbarData, 'zoomLevel', parseFloat((this.toolbarData['zoomLevel'] + (parseFloat((this.toolbarData['zoomLevel'] + 0.1).toFixed(1)) > 2 ? 0 : 0.1)).toFixed(1)));
            this.$set(this.toolbarData, 'zoomLevelInv', (1 / this.toolbarData['zoomLevel']));
            
            setTimeout(() => { this.pagerScroll();}, 1);

            //-- Set the page's offset relative to body
            setTimeout(() => { 
              this.$set(this.editorData, 'pageOffsetX', (pageDOM.getBoundingClientRect()['left'] - pagerDOM.getBoundingClientRect()['left'] + this.mouseData['pagerScrollLeft']));
              this.$set(this.editorData, 'pageOffsetY', ((pageDOM.getBoundingClientRect()['top'] - pagerDOM.getBoundingClientRect()['top']) + this.mouseData['pagerScrollTop']) + 30);
            }, 1);
            break;
          case 'pageUp':
            if (this.toolbarData['pageCurrent'] > 1) {
              pagerDOM.scrollTo(pagerDOM['scrollLeft'], (this.toolbarData['pageCurrent'] - 2) * (this.pageData['heightpx'] * this.toolbarData['zoomLevel']));
            }
            break;
          case 'pageDown':
            if (this.toolbarData['pageCurrent'] < this.toolbarData['pageTotal']) {
              pagerDOM.scrollTo(pagerDOM['scrollLeft'], this.toolbarData['pageCurrent'] * (this.pageData['heightpx'] * this.toolbarData['zoomLevel']));
            }
            break;
          case 'print':
            //-- Close the hamburger menu
            this.$set(this.toolbarData, 'hamburgerShow', false);

            //-- Set initial variables
            var zoomLevel = this.toolbarData['zoomLevel'];

            //-- Prepare for printing
            this.$set(this.toolbarData, 'zoomLevel', 1);
            this.$set(this.mainData, 'print', true);

            setTimeout(async () => {
              //-- Get CSS / Print Page CSS (Can configure)
              var list = document.documentElement.getElementsByTagName('style');
              var css = '';
              for (let c of list) { css += c.outerHTML; }
              css += '<style>'
              css += '@page { size: ' + this.pageData['selection'] + ' portrait; padding: 0px; margin: 0px; }';
              css += '* { -webkit-print-color-adjust: exact; box-sizing: border-box; }';
              css += 'body { margin: 0px; }';
              css += '</style>';

              // console.log(await this.getAllStyles(this.$refs['pageMain']))
              var mywindow = window.open('_blank', 'PRINT');
              mywindow['document'].write(`<html><head><title>Report Designer</title>` + css);
              mywindow['document'].write('</head><body>');
              mywindow['document'].write('</body></html>');

              //-- Format ALL elements with computed CSS
              //-- Main Page
              var pageDOM = this.$refs['pageMain'].cloneNode(false);
              pageDOM['style'] = await this.getAllStyles(this.$refs['pageMain']);

              //-- Child Nodes
              Array.from(this.$refs['pageMain'].childNodes).forEach(async (c, i) => {
                if (c['className'].search('pageBreak') >= 0) {
                  var childDOM = c.cloneNode(false);

                  var imgDOM = c.getElementsByClassName('pageBreakImg')[0].cloneNode(true);
                  imgDOM['style'] += await this.getAllStyles(c.getElementsByClassName('pageBreakImg')[0]);
                  imgDOM['style']['border'] = 'none';
                  childDOM.appendChild(imgDOM);

                  childDOM['style'] += await this.getAllStyles(c);
                  pageDOM.appendChild(childDOM);
                } else { 
                  var childDOM = c.cloneNode(true);
                  childDOM['style'] += await this.getAllStyles(c);
                  pageDOM.appendChild(childDOM);
                }
              });
              
              //-- Append page to new window
              await mywindow['document']['body'].appendChild(pageDOM);

              //-- Print the page
              setTimeout(() => {
                mywindow.document.close(); // necessary for IE >= 10
                mywindow.focus(); // necessary for IE >= 10*/

                mywindow.print();
                mywindow.close(); 
              }, 1);

              //-- Reset to initial variables
              this.$set(this.toolbarData, 'zoomLevel', zoomLevel);
              this.$set(this.mainData, 'print', false);
            }, 1);

            break;
          case 'reset':
            //-- Reset Selection
            this.$set(this.pageData, 'selection', 'A4');

            //-- Reset Pages
            this.$set(this.mainData, 'pages', [JSON.parse(JSON.stringify(this.pageDefault['A4']))]);
            this.$set(this.mainData, 'fields', []);

            //-- Refresh sizing and images
            this.$nextTick(() => {
              this.loadImg();
              this.sizeChange();
            });

            //-- Close the hamburger menu
            this.$set(this.toolbarData, 'hamburgerShow', false);
            break;
          case 'console':
            switch(data) {
              case 'data':
                // console.log(this.mainData['pages']);
                // console.log(this.mainData['fields']);
                break;
            }
            break;
          case 'cancel':
            //-- Close the hamburger menu
            this.$set(this.toolbarData, 'hamburgerShow', false);
            this.$emit('cancel');
            break;
        }
      },
      getAllStyles: async function(elem) {
        //-- Element does not exist
        if (!elem) { return ''; }

        //-- Element exists
        var win = document.defaultView || window, style, styleNode = [];
        if (win.getComputedStyle) { /* Modern browsers */
            style = win.getComputedStyle(elem, '');
            for (var i = 0; i < style['length']; i++) { styleNode.push(style[i] + ':' + style.getPropertyValue(style[i]) + ';'); }
        } else if (elem.currentStyle) { /* IE */
            style = elem.currentStyle;
            for (var name in style) { styleNode.push(name + ':' + style[name] + ';'); }
        } else { /* Ancient browser..*/
            style = elem.style;
            for (var i = 0; i < style['length']; i++) { styleNode.push(style[i] + ':' + style[style[i]] + ';'); }
        }

        //-- Return into a string format
        var css = '';
        styleNode.forEach((s, i) => { css += s; });
        return css;
      },
      getOverflow: async function() {
        //-- Get non-default fields and remove (to avoid duplicates if this method is called more than twice)
        var nonDefaultFields = this.mainData['fields'].filter((f, i) => {
          return !f['properties']['default'];
        });
        // console.log('%cNon Defaults', 'color: #f88', nonDefaultFields);
        
        nonDefaultFields.forEach((nd, i) => {
          var fieldIndex = this.mainData['fields'].indexOf(nd);
          var fieldObj = this.mainData['fields'].splice(fieldIndex, 1);
        });

        //-- Get fields that have overflow on true
        var overflowFields = this.mainData['fields'].filter((f, i) => {
          return f['properties']['overflow'];
        });

        // console.log(overflowFields);
        if (overflowFields['length'] > 0) {
          overflowFields.forEach((f, i) => {
            switch(f['type']) {
              case 'text':
                break;
              case 'table':
                break;
              case 'tsmanifest':
                //-- For TS Manifest (Watson's), each sheet can only hold THREE (3) items

                //-- Copy the list and format the jobs(avoid referencing or loss of data)
                var jobsList = [];
                if (this.data && (this.data['Stores'] && this.data['Stores']['length'] > 0)) {
                  this.data['Stores'].forEach((s, i4) => {
                    // if (s['Consignment']['length'] > 0) {
                    //   s['Consignment'].forEach((c, i5) => {
                    //     jobsList.push(JSON.parse(JSON.stringify(c)))
                    //     // console.log(c['SeqNo']);
                    //   });
                    // }
                    
                    jobsList.push(JSON.parse(JSON.stringify(s)))
                  });
                }
                // console.log(JSON.parse(JSON.stringify(jobsList)));

                //-- Get total actual length (for generation purposes)
                var jobsLength = Math.floor((jobsList['length']) / 3);
                // console.log(jobsLength);

                //-- Add details to initial field
                var jobsDetails = JSON.parse(JSON.stringify(this.data));
                if (jobsDetails && jobsDetails['Stores']) { delete jobsDetails['Stores']; }
                this.$set(f['properties'], 'details', jobsDetails);

                //-- Apply first 3 items into initial field 
                //-- Clear initial field data (data was rendered before actual data came in, causing undefined issue)
                this.$set(f['properties'], 'jobs', []);
                if (jobsList['length'] > 0) {
                  for (var i = 0; i < 3; i++) { 
                    var job = jobsList.splice(0, 1)[0]; 
                    
                    if (job) {
                      //-- Set SeqNo
                      this.$set(job, 'SeqNo', (i + 1));
                    }

                    //-- Push item into field
                    f['properties']['jobs'].push(job);
                  }
                }

                //-- Assign new fields
                for (var i2 = 0; i2 < jobsLength; i2++) {
                  if (jobsList['length']) {
                    var newField = JSON.parse(JSON.stringify(this.fieldDefault[f['type']]));

                    //-- Set new ID
                    var fieldID = [];
                    this.mainData['fields'].forEach((f1) => { fieldID.push(parseInt(f1['id'])); });
                    this.$set(newField, 'id', fieldID['length'] > 0 ? (Math.max.apply(null, fieldID) + 1) : 0);
                    
                    //-- Set position
                    this.$set(newField, 'posX1', f['posX1']);
                    this.$set(newField, 'posY1', f['posY1'] + (this.pageDefault[this.pageData['selection']]['properties']['heightpx'] * (i2 + 1)));
                    this.$set(newField, 'posX2', f['posX2']);
                    this.$set(newField, 'posY2', f['posY2'] + ((this.pageDefault[this.pageData['selection']]['properties']['heightpx'] - 0.1) * (i2 + 1)));

                    //-- Set non default
                    this.$set(newField['properties'], 'default', false);

                    //-- Add details
                    var jobsDetails = JSON.parse(JSON.stringify(this.data));
                    if (jobsDetails['Stores']) { delete jobsDetails['Stores']; }
                    this.$set(newField['properties'], 'details', jobsDetails);

                    //-- Add items (3 each)
                    for (var i3 = 0; i3 < 3; i3++) { 
                      if (jobsList['length'] > 0) {
                        var job = jobsList.splice(0, 1)[0];

                        if (job) {
                          //-- Set SeqNo
                          this.$set(job, 'SeqNo', ((i3 + 4) + (i2 * 3)));
                        }

                        newField['properties']['jobs'].push(job);
                      }
                    }
                    
                    //-- Add the field to render
                    this.mainData['fields'].push(newField);

                    //-- Load Images
                    this.$nextTick(() => { this.loadImg(); }); 
                  }
                }

                //-- Check for overflow
                this.pagerCheckOverflow();
                break;
              case 'cnehl':
              case 'cnfmh':
              case 'cnej':
              case 'cntsl':
                let cnList = this.data['ConsignmentNote'] ? this.data['ConsignmentNote'] : [];

                let jobDetails = JSON.parse(JSON.stringify(this.data));
                delete jobDetails['ContDetail'];
                delete jobDetails['ConsignmentNote'];

                this.$set(f['properties'], 'cns', null);
                cnList.forEach((cn, i) => {
                  let newField = JSON.parse(JSON.stringify(this.fieldDefault['consignment']));
                  newField['type'] = this.mainData['fields'][0]['type'];
                  
                  //#region Set new ID
                  let fieldID = [];
                  this.mainData['fields'].forEach((f1) => { fieldID.push(parseInt(f1['id'])); });
                  this.$set(newField, 'id', fieldID['length'] > 0 ? (Math.max.apply(null, fieldID) + 1) : 0);
                  //#endregion

                  //#region Set Position
                  this.$set(newField, 'posX1', f['posX1']);
                  this.$set(newField, 'posY1', f['posY1'] + (this.pageDefault[this.pageData['selection']]['properties']['heightpx'] * (i)));
                  this.$set(newField, 'posX2', f['posX2']);
                  this.$set(newField, 'posY2', f['posY2'] + ((this.pageDefault[this.pageData['selection']]['properties']['heightpx'] - 0.1) * (i)));
                  //#endregion

                  this.$set(newField['properties'], 'default', false);

                  newField['properties']['cns'] = cn;
                  newField['properties']['details'] = jobDetails;

                  this.mainData['fields'].push(newField);
                })

                this.pagerCheckOverflow();
                break;
            }
          });
        }
      },

      //---- Editor Methods
      editorBtn: async function(cmd, data, e) {
        switch(cmd) {
          case 'resize':
            this.$set(this.mouseData, 'editorResizeMouseDown', true);
            this.$set(this.mouseData, 'editorResizeType', data);
        
            this.$set(this.mouseData, 'pagerMousePosX', e['clientX']);
            this.$set(this.mouseData, 'pagerMousePosY', e['clientY']);
            break;
        }
      },

      pageAutoGenerate: async function() {
        var formJson = await this.$apiCallV2('/ReportDesigner/ReadFiles?folderPath=ROTform&fileName=' + this.mainData['form']);

        var autoGenTables = formJson['data']['fields'].filter(t => t['type'] == "table" && t['properties']['autoGenerate'] == true);
        // console.log(autoGenTables);

        var valueKey = '';
        var itemKey = '';
        var itemKeyValue = [];
        var value = [];
        var overflowed = false;

        autoGenTables.forEach(t => {
          if (typeof t['properties']['cellDefault']['value'] !== 'undefined') {
            valueKey = t['properties']['cellDefault']['value'].slice(1, -1);
            // console.log(valueKey);
          }
          itemKey = t['properties']['itemKey'];
          itemKeyValue = this.mainData['data'][itemKey];
          // console.log(itemKeyValue);

          // check if the number of rows of data overshoots the number of allocated table rows on the form
          if (itemKeyValue.length > t['properties']['numRow']) {
            overflowed = true;
            // console.log('overflowed');
          } else {
            overflowed = false;
            // console.log('not overflowed');
          }

          // if overflowed, add the data on each row to an array
          if (overflowed) {
            itemKeyValue.forEach( ikv => value.push(ikv[valueKey]) );
            // console.log(itemKeyValue);
          }

          // TO DO:
          // << add new text and table fields further down the Y-axis into the 2nd page onwards >>
          // << populate the fields with the data from the value array >>
          // << update this.mainData['pages'] and this.mainData['fields'] and this.mainData['data'] >>
          // << execute this.dataChange(); and this.$nextTick(() => { this.loadForm(); }); >>

        });
        // console.log('mainData');
        // console.log(this.mainData);
      },
      
      //---- Pager Methods
      pagerDblClick: async function(cmd, e) {
        //-- Trigger for new field
        if (e['target']['id'] == 'page') {

          //-- Open the New Field Menu
          // this.$set(this.editorData, 'newFieldShow', true);
          // this.$set(this.editorData, 'newFieldPosX', e['offsetX'] * this.toolbarData['zoomLevelInv']);
          // this.$set(this.editorData, 'newFieldPosY', e['offsetY'] * this.toolbarData['zoomLevelInv']);
          // console.log(e);
        
        //-- If only the page was clicked (somewhat reset for editor, selected field, etc)
        }
      },
      pagerMouseDown: async function(cmd, e) {
        this.$set(this.toolbarData, 'hamburgerShow', false);

        //-- Disallows movement of field if clicking on anything OTHER THAN the field or page
        if (e['target']['id'].search('field') >= 0) {
          this.$set(this.mouseData, 'pagerMouseDown', true);
        }
        
        if (!this.quickPrint) {
          this.$set(this.mouseData, 'pagerMousePosX', e['clientX']);
          this.$set(this.mouseData, 'pagerMousePosY', e['clientY']);

          //-- Trigger for new field
          if (e['shiftKey'] && e['target']['id'] == 'page') {
            this.$set(this.editorData, 'pageSel', null);
            if (this.editorData['fieldSel']) {
              this.$set(this.editorData['fieldSel']['properties'], 'selected', false);
              this.$set(this.editorData, 'fieldSel', null);
            }

            //-- Open the New Field Menu
            this.$set(this.editorData, 'newFieldShow', true);
            this.$set(this.editorData, 'newFieldPosX', e['offsetX'] * this.toolbarData['zoomLevelInv']);
            this.$set(this.editorData, 'newFieldPosY', e['offsetY'] * this.toolbarData['zoomLevelInv']);
            // console.log(e);
          
          //-- If only the page was clicked (somewhat reset for editor, selected field, etc)
          } else if ((e['target']['id'] == 'page') || (e['target']['id'] == 'pager')) {
            this.$set(this.editorData, 'pageSel', null);
            if (this.editorData['fieldSel']) {
              this.$set(this.editorData['fieldSel']['properties'], 'selected', false);
              this.$set(this.editorData, 'fieldSel', null);
            }

            //-- Reset New Field Menu
            this.$set(this.editorData, 'newFieldShow', false);
            this.$set(this.editorData, 'newFieldPosX', 0);
            this.$set(this.editorData, 'newFieldPosY', 0);
          }
        }

      },
      pagerMouseUp: async function(cmd, e) {
        //-- Check if field was clicked WITHOUT moving
        // console.log(e)

        //-- Load images
        // if (this.mouseData['pagerMouseDown']) {
        //   this.loadImg();
        // }

        this.$set(this.mouseData, 'pagerMouseDown', false);
        this.$set(this.mouseData, 'pagerMouseMove', false);

        //-- Editor Resize Reset
        this.$set(this.mouseData, 'editorResizeMouseDown', false);

        //-- Recheck for empty pages
        this.pagerCheckOverflow();
      },
      pagerMouseMove: async function(cmd, e) {
        //-- Set focus to false if Moving
        if (this.editorData['fieldSel'] && (this.mouseData['pagerMouseDown'] || this.mouseData['editorResizeMouseDown'])) {
          this.$set(this.editorData['fieldSel']['properties'], 'focus', false);
        }

        //-- Move the field
        if (this.editorData['fieldSel'] && this.mouseData['pagerMouseDown']) {
          //-- Set a check for if mouse was moving
          this.$set(this.mouseData, 'pagerMouseMove', true);

          if (e['shiftKey']) {
            var fieldWidth = this.editorData['fieldSel']['posX2'] - this.editorData['fieldSel']['posX1'];
            var fieldHeight = this.editorData['fieldSel']['posY2'] - this.editorData['fieldSel']['posY1'];
            
            var newX = (((e['clientX'] - this.$refs['pageMain'].getBoundingClientRect()['left']) * this.toolbarData['zoomLevelInv']) - (fieldWidth / 2)) - ((((e['clientX'] - this.$refs['pageMain'].getBoundingClientRect()['left']) * this.toolbarData['zoomLevelInv']) - (fieldWidth / 2)) % (this.pageDefault[this.pageData['selection']]['properties']['widthpx'] / this.pageDefault[this.pageData['selection']]['properties']['widthmm']));
            var newY = (((e['clientY'] - this.$refs['pageMain'].getBoundingClientRect()['top']) * this.toolbarData['zoomLevelInv']) - (fieldHeight / 2)) - ((((e['clientY'] - this.$refs['pageMain'].getBoundingClientRect()['top']) * this.toolbarData['zoomLevelInv']) - (fieldHeight / 2)) % (this.pageDefault[this.pageData['selection']]['properties']['widthpx'] / this.pageDefault[this.pageData['selection']]['properties']['widthmm']));
          
            this.$set(this.editorData['fieldSel'], 'posX1', newX);
            this.$set(this.editorData['fieldSel'], 'posY1', newY);
            this.$set(this.editorData['fieldSel'], 'posX2', fieldWidth + newX);
            this.$set(this.editorData['fieldSel'], 'posY2', fieldHeight + newY);

          } else {
            var newX = ((e['clientX'] - this.mouseData['pagerMousePosX']) * this.toolbarData['zoomLevelInv']);
            var newY = ((e['clientY'] - this.mouseData['pagerMousePosY']) * this.toolbarData['zoomLevelInv']);
            
            this.$set(this.editorData['fieldSel'], 'posX1', (this.editorData['fieldSel']['posX1']) + newX);
            this.$set(this.editorData['fieldSel'], 'posY1', (this.editorData['fieldSel']['posY1']) + newY);
            this.$set(this.editorData['fieldSel'], 'posX2', (this.editorData['fieldSel']['posX2']) + newX);
            this.$set(this.editorData['fieldSel'], 'posY2', (this.editorData['fieldSel']['posY2']) + newY);
          }
        
          this.$set(this.mouseData, 'pagerMousePosX', e['clientX']);
          this.$set(this.mouseData, 'pagerMousePosY', e['clientY']);

          this.pagerCheckOverflowNoRemove();
        }

        //-- Resize the field
        if (this.editorData['fieldSel'] && this.mouseData['editorResizeMouseDown']) {
          //-- Set a check for if mouse was moving
          this.$set(this.mouseData, 'pagerMouseMove', true);

          if (e['shiftKey']) {
            var newX = (e['layerX'] * this.toolbarData['zoomLevelInv']) - ((e['layerX'] * this.toolbarData['zoomLevelInv']) % (this.pageDefault[this.pageData['selection']]['properties']['widthpx'] / this.pageDefault[this.pageData['selection']]['properties']['widthmm']));
            var newY = (e['layerY'] * this.toolbarData['zoomLevelInv']) - ((e['layerY'] * this.toolbarData['zoomLevelInv']) % (this.pageDefault[this.pageData['selection']]['properties']['widthpx'] / this.pageDefault[this.pageData['selection']]['properties']['widthmm']));
            
            switch (this.mouseData['editorResizeType']) {
              case 'nw':
                this.$set(this.editorData['fieldSel'], 'posX1', newX);
                this.$set(this.editorData['fieldSel'], 'posY1', newY);
                break;
              case 'ne':
                this.$set(this.editorData['fieldSel'], 'posX2', newX);
                this.$set(this.editorData['fieldSel'], 'posY1', newY);
                break;
              case 'sw':
                this.$set(this.editorData['fieldSel'], 'posX1', newX);
                this.$set(this.editorData['fieldSel'], 'posY2', newY);
                break;
              case 'se':
                this.$set(this.editorData['fieldSel'], 'posX2', newX);
                this.$set(this.editorData['fieldSel'], 'posY2', newY);
                break;
            }
          } else {
            var newX = ((e['clientX'] - this.mouseData['pagerMousePosX']) * this.toolbarData['zoomLevelInv']);
            var newY = ((e['clientY'] - this.mouseData['pagerMousePosY']) * this.toolbarData['zoomLevelInv']);
            
            switch (this.mouseData['editorResizeType']) {
              case 'nw':
                this.$set(this.editorData['fieldSel'], 'posX1', (this.editorData['fieldSel']['posX1']) + newX);
                this.$set(this.editorData['fieldSel'], 'posY1', (this.editorData['fieldSel']['posY1']) + newY);
                break;
              case 'ne':
                this.$set(this.editorData['fieldSel'], 'posX2', (this.editorData['fieldSel']['posX2']) + newX);
                this.$set(this.editorData['fieldSel'], 'posY1', (this.editorData['fieldSel']['posY1']) + newY);
                break;
              case 'sw':
                this.$set(this.editorData['fieldSel'], 'posX1', (this.editorData['fieldSel']['posX1']) + newX);
                this.$set(this.editorData['fieldSel'], 'posY2', (this.editorData['fieldSel']['posY2']) + newY);
                break;
              case 'se':
                this.$set(this.editorData['fieldSel'], 'posX2', (this.editorData['fieldSel']['posX2']) + newX);
                this.$set(this.editorData['fieldSel'], 'posY2', (this.editorData['fieldSel']['posY2']) + newY);
                break;
            }

          }

          this.$set(this.mouseData, 'pagerMousePosX', e['clientX']);
          this.$set(this.mouseData, 'pagerMousePosY', e['clientY']);

          this.pagerCheckOverflowNoRemove();
        }
      },
      pagerMouseOver: async function(cmd, e) {
        this.$set(this.mouseData, 'pagerMouseOver', true);
      },
      pagerMouseLeave: async function(cmd, e) {
        this.$set(this.mouseData, 'pagerMouseOver', false);
        
        this.pagerMouseUp(cmd, e);
      },
      pagerScroll: async function(cmd, e) {
        var pagerDOM = this.$refs['pagerMain'];
        this.$set(this.toolbarData, 'pageCurrent', Math.ceil((pagerDOM['scrollTop'] + 20) / (this.pageData['heightpx'] * this.toolbarData['zoomLevel'])));
      
        //-- Pager scroll offsets
        this.$set(this.mouseData, 'pagerScrollTop', pagerDOM['scrollTop']);
        this.$set(this.mouseData, 'pagerScrollLeft', pagerDOM['scrollLeft']);
      },
      pagerCheckOverflowNoRemove: async function() {
        this.mainData['fields'].forEach((f) => {
          if (f['posY2'] > this.toolbarData['fieldLowestpx']) { this.$set(this.toolbarData, 'fieldLowestpx', f['posY2']); }
        });
        // console.log(this.toolbarData['fieldLowestpx']);

        this.$set(this.toolbarData, 'pageTotal', Math.ceil((((this.toolbarData['fieldLowestpx'] - 110) * this.toolbarData['zoomLevel']) / (this.pageData['heightpx'] * this.toolbarData['zoomLevel'])) + 0.1));
        
        this.pagerCheckBreakers();
      },
      pagerCheckOverflow: async function() {
        var lowestpx = 0;
        this.mainData['fields'].forEach((f) => {
          if (f['posY2'] > lowestpx) { lowestpx = f['posY2']; }
        });
        this.$set(this.toolbarData, 'fieldLowestpx', lowestpx);
        
        var newTotal = Math.ceil(((this.toolbarData['fieldLowestpx'] * this.toolbarData['zoomLevel']) / (this.pageData['heightpx'] * this.toolbarData['zoomLevel'])));
        this.$set(this.toolbarData, 'pageTotal', newTotal <= 0 ? 1 : newTotal);

        this.pagerCheckBreakers();
      },
      pagerCheckBreakers: async function() {
        //-- Check for existing pages, remove if exceed counter
        var pageArr = [];
        for (var i = 0; i < this.toolbarData['pageTotal']; i++) {
          if (this.mainData['pages'][i]) {
            pageArr.push(this.mainData['pages'][i]);
          } else {
            var newPage = JSON.parse(JSON.stringify(this.pageDefault['A4']));

            //-- Set New ID
            this.$set(newPage, 'id', i);
            // this.$set(newPage, 'image', this.mainData['pages']['image'] ? this.mainData['pages']['image'] : this.mainData['pages'][this.mainData['pages']['length'] - 1]['image']);

            pageArr.push(newPage);

            this.$nextTick(() => {
              this.loadImg();
            });
          }
        }
        this.$set(this.mainData, 'pages', pageArr);
      },

      //---- Field Methods
      fieldNew: async function(cmd, data, e) {
        var newField = JSON.parse(JSON.stringify(this.fieldDefault[cmd]));
        // console.log(newField);

        //-- Set new ID
        var fieldID = [];
        this.mainData['fields'].forEach((f) => { fieldID.push(parseInt(f['id'])); });
        this.$set(newField, 'id', fieldID['length'] > 0 ? (Math.max.apply(null, fieldID) + 1) : 0);

        //-- Set custom properties per field type
        if (data) {
          //-- This one is used for Legacy support, to add in custom data wherever needed
          switch(cmd) {
            case 'text':
              //-- Set field position
              this.$set(newField, 'posX1', data['posX1']);
              this.$set(newField, 'posY1', data['posY1']);

              //-- Set field size relevant to position
              this.$set(newField, 'posX2', data['posX2']);
              this.$set(newField, 'posY2', data['posY2']);
              
              //-- Set properties
              this.$set(newField['properties'], 'fontFamily', data['fontFamily']);
              this.$set(newField['properties'], 'fontSize', data['fontSize']);
              this.$set(newField['properties'], 'fontWeight', data['fontWeight']);
              this.$set(newField['properties'], 'fontJustify', data['fontJustify']);
              this.$set(newField['properties'], 'fontOverflow', data['fontOverflow']);
              this.$set(newField['properties'], 'value', data['value']);
              break;
            case 'table':
              //-- Set field position
              this.$set(newField, 'posX1', data['posX1']);
              this.$set(newField, 'posY1', data['posY1']);

              //-- Set field size relevant to position
              this.$set(newField, 'posX2', data['posX2']);
              this.$set(newField, 'posY2', data['posY2']);
              
              //-- Set properties
              this.$set(newField['properties']['cellDefault'], 'fontFamily', data['fontFamily']);
              this.$set(newField['properties']['cellDefault'], 'fontSize', data['fontSize']);
              this.$set(newField['properties']['cellDefault'], 'fontWeight', data['fontWeight']);
              this.$set(newField['properties']['cellDefault'], 'fontJustify', data['fontJustify']);
              this.$set(newField['properties']['cellDefault'], 'fontOverflow', data['fontOverflow']);
              this.$set(newField['properties']['cellDefault'], 'value', data['value']);
              this.$set(newField['properties'], 'numInd', data['numInd']);
              this.$set(newField['properties'], 'numCol', data['numCol']);
              this.$set(newField['properties'], 'numRow', data['numRow']);
              this.$set(newField['properties'], 'itemKey', data['itemKey']);
              this.$set(newField['properties'], 'border', data['border']);
              // console.log(newField);
              break;
            case 'tsmanifest':
              break;

                          // 'fontFamily': 'Arial, sans-serif',
                          // 'fontSize': 11,
                          // 'fontWeight': f2['textWeight'],
                          // 'fontJustify': f2['textJustify'],
                          // 'fontOverflow': true,
          }
        } else {
          //-- This is the usual one as of now, adds in new fields/pages
          switch(cmd) {
            case 'text':
            case 'table':
              //-- Set field position
              this.$set(newField, 'posX1', this.editorData['newFieldPosX'] - (newField['posX2'] / 2));
              this.$set(newField, 'posY1', this.editorData['newFieldPosY'] - (newField['posY2'] / 2));

              //-- Set field size relevant to position
              this.$set(newField, 'posX2', (this.editorData['newFieldPosX'] + newField['posX2']) - (newField['posX2'] / 2));
              this.$set(newField, 'posY2', (this.editorData['newFieldPosY'] + newField['posY2']) - (newField['posY2'] / 2));
              break;
            case 'tsmanifest':
              break;
          }
        }

        //-- Push field into page
        this.mainData['fields'].push(newField);

        this.$nextTick(() => {
          //-- Reset New Field Menu
          this.$set(this.editorData, 'newFieldShow', false);
          this.$set(this.editorData, 'newFieldPosX', 0);
          this.$set(this.editorData, 'newFieldPosY', 0);
        });
      },
      fieldMouseDown: async function(cmd, e) {
        if (!this.quickPrint && (e['target']['id'].search('field') >= 0)) {
          if (this.editorData['fieldSel']) {
            this.$set(this.editorData['fieldSel']['properties'], 'selected', false);
          }

          this.$nextTick(() => {
            this.$set(this.editorData, 'fieldSel', cmd);
            this.$set(this.editorData['fieldSel']['properties'], 'selected', true);
            
            //-- Close the Page editor
            this.$set(this.editorData, 'pageSel', null);
          });
        }
      },
      fieldMouseUp: async function(cmd, e) {
        if (!this.quickPrint) {
          if (!this.mouseData['pagerMouseMove'] && (e['target']['id'] == 'field')) {
            // console.log(cmd);
            this.$set(cmd['properties'], 'focus', true);
          }
        }
      },


    },
    watch: {
      // template: { deep: true, handler(h) { /*code*/ } },
      data: { deep: true, handler(h) { this.dataChange(); } },
      form: { deep: true, handler(h) { this.formChange(); } },
    },
  };
</script>

<style scoped>

  .designerMain {
    width: 100%;
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: #dddf;
    overflow: hidden;
    /* white-space: pre; */
  }

  /* -- Controls CSS -- */
  body button {
    width: 30px;
    height: 30px;
    font-size: 12px;
    line-height: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #444f;
    border-radius: 0px;
  }
  
  body button:hover {
    background-color: #555f;
  }
  
  body button:focus {
    border: none;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  body button svg {
    width: auto;
    height: auto;
    position: absolute;
    top: 1px;
    bottom: 1px;
    left: 1px;
    right: 1px;
    fill: #ffff;
    stroke: #ffff;
    stroke-width: 12px;
    pointer-events: none;
  }

  body button.selected {
    border: solid 1px #aaaf;
  }

  body button.selected svg {
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
  }

  body input {
    width: 100%;
    height: 26px;
    padding: 0 2px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }

  body input:hover {
    border: solid 1px #0004;
  }
  
  body input:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  body input:disabled {
    background-color: #dddf;
  }
  
  body select {
    width: 100%;
    height: 26px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }

  body select:hover {
    border: solid 1px #0004;
  }
  
  body select:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
  
  body textarea {
    width: 100%;
    padding: 0 2px;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
    resize: none;
  }

  body textarea:hover {
    border: solid 1px #0004;
  }
  
  body textarea:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  /* -- Console CSS -- */
  .consoleMain {
    width: auto;
    height: 12px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .consoleSpacer {
    width: 8px;
    height: 100%;
  }

  .consoleInd {
    width: 16px;
    height: 100%;
    margin: 0 1px;
    font-size: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #aaaf;
    border: solid 1px #888f;
    user-select: none;
    pointer-events: none;
  }

  .power {
    background-color: #5db073;
  }

  /* -- Toolbar CSS -- */
  .toolbarMain {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #444f;
    box-shadow: 0 0 10px #0008;
    z-index: 30;
  }

  .toolbarHamburgerMain {
    width: auto;
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }

  .toolbarHamburger {
    width: 200px;
    height: auto;
    position: absolute;
    top: 30px;
    left: 0px;
  }

  .toolbarHamburgerBtn {
    width: 100%;
    height: 24px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #dddf;
  }

  .toolbarFunctionsMain {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .toolbarSection {
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .toolBarSectionBorder {
    width: 1px;
    height: 65%;
    margin: 0 2px;
    background-color: #aaaf;
  }

  .toolbarSectionInput {
    width: 60px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /* -- Editor CSS -- */
  .editorMain {
    position: absolute;
    border: solid 1px hotpink;
    pointer-events: none;
    user-select: none;
    z-index: 20;
  }

  .editorResize {
    width: 6px;
    height: 6px;
    position: absolute;
    background-color: hotpink;
    pointer-events: all;
  }

  .editorDefocus {
    width: 6px;
    position: absolute;
    background-color: #ff69b488;
    pointer-events: all;
  }

  /* -- New Field CSS -- */
  .newFieldMain {
    width: 200px;
    height: 200px;
    padding: 5px;
    position: absolute;
    top: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: #444f;
    z-index: 20;
  }
  
  .newFieldTitle {
    width: 100%;
    height: 16px;
    margin: 0 0 5px 0;
    font-size: 12px;
    color: #ffff;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    z-index: 20;
  }

  .newFieldList {
    width: 100%;
    height: auto;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: #ffff;
  }

  .newFieldItem {
    width: 100%;
    height: 20px;
    padding: 0 5px;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    user-select: none;
    cursor: pointer;
  }

  .newFieldItem:hover {
    background-color: #eeef;
  }
  
  /* -- Pager CSS -- */
  .pagerMain {
    width: 100%;
    height: auto;
    padding: 40px 0;
    flex: 1;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    overflow: scroll;
    scroll-behavior: smooth;
  }

  .pageMargin {
    width: auto;
    height: 80px;
  }

  .pageMain {
    position: relative;
    background-color: #ffff;
    box-shadow: 0 0 10px #0008;
  }

  .pageBreak {
    width: 100%;
    height: 1px;
    position: absolute;
    pointer-events: none;
  }

  .pageBreak > .pageGrid {
    width: auto;
    height: auto;
    position: absolute;
    top: 0px;
    left: 0px;
    right: 0px;
    fill: #0004;
    stroke: #0004;
    stroke-width: 0.5px;
    pointer-events: none;
    z-index: 10;
  }

  .pageBreakText {
    width: 32px;
    height: 20px;
    font-size: 12px;
    color: #ffff;
    position: absolute;
    top: -10px;
    right: -34px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;
    z-index: 10;
  }

  .pageBreak svg {
    width: 32px;
    height: 20px;
    position: absolute;
    top: -10px;
    right: -34px;
    fill: #444f;
    stroke: #0008;
    stroke-width: 30px;
    pointer-events: all;
    cursor: pointer;
    transition: 0.3s;
  }

  .pageBreak svg:hover {
    fill: #555f;
  }

  .pageBreakImg {
    position: absolute;
    top: 0px;
    top: 0px;
    left: 0px;
    right: 0px;
    background-color: #ffff;
    background-size: 100% auto;
    background-repeat: no-repeat;
    background-position: center top;
    image-rendering: -webkit-optimize-contrast;
  }

  .pageEditorMain {
    width: 200px;
    height: 100px;
    padding: 5px;
    position: absolute;
    top: 15px;
    right: -34px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    background-color: #444f;
    pointer-events: all;
    z-index: 20;
  }

  .pageEditorMain > select {
    margin: 0 0 5px 0;
  }

  /* -- Field CSS -- */
  .fieldMain {
    position: absolute;
    user-select: none;
    z-index: 10;
  }

  /* -- Save CSS -- */
  .saveMain {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 0px;
    right: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0004;
    z-index: 2000;
  }
  
  .saveBody {
    width: 300px;
    height: 240px;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    background-color: #ffff;
    border-radius: 4px;
    box-shadow: 0 0 8px #0004;
  }

  .saveList { 
    width: 100%;
    height: auto;
    padding: 0 5px;
    margin: 5px 0;
    font-size: 12px;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    overflow-x: hidden;
    overflow-y: scroll;
    user-select: none;
  }

  .saveFunctions {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  .saveButton {
    width: auto;
    height: 26px;
    margin: 0 0 0 5px;
    font-size: 12px;
    line-height: 16px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #ffff;
    border: solid 1px #0002;
    border-radius: 0px;
  }
  
  .saveButton:hover {
    background-color: #eeef;
  }
  
  .saveButton:focus {
    border: solid 1px #0002;
    box-shadow: none;
    outline: none;

    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }
</style>